// Basic Vue components
import { createApp } from 'vue'
import 'vue-style-loader';

// Setup Vue
window.Vue = createApp;
window.$ = window.jQuery = jQuery;

// Our extensions and components
import Axios from './classes/Axios.js';
import autocomplete from './components/autocomplete.vue';
import modalDynamic from './components/modal-dynamic.vue';
import oasisModal from './components/oasis-modal.vue';
import calendar from './components/calendar.vue';
import timecardDay from './components/timecardDay.vue';
import allocation from './components/allocation.vue';
import Dropzone from 'vue2-dropzone';
import TimecardMixin from './mixins/TimecardMixin';
import DropzoneMixin from './mixins/DropzoneMixin';
import COAMixin from './mixins/COAMixin.js';
import unionSchedule from './components/unionSchedule.vue';
import UtilitiesMixin from './mixins/UtilitiesMixin.js';
import AllowanceTimecard from './components/AllowanceTimecard.vue';
import TimecardReviewBox from './components/TimecardReviewBox.vue';
import { debounce } from 'lodash';
import DateFormatUtil from './mixins/DateFormatUtil.js';
import { DateTime } from 'luxon';

require ('./classes/PrototypeExt.js');
var app = createApp({
    // store: tcstore,

    components: {
      autocomplete,
      calendar,
      allocation,
      'timecard-day': timecardDay,
      'modal-dynamic': modalDynamic,
      'oasis-modal': oasisModal,
      Dropzone,
      'union-schedule': unionSchedule,
      AllowanceTimecard,
      TimecardReviewBox,
    },

    mixins: [ TimecardMixin, DropzoneMixin, UtilitiesMixin, COAMixin, DateFormatUtil ],

    data() {
        return {
            enableWorkDay: false,
            isRefreshStart: false,
            previousPrComment: '',
            isPrCommentsDisabled: true,
            oasisApi: new Axios('/restv2'),
            oasisV3Api: new Axios('/restv3'),
            modified: false,
            isNew: true,
            true: true,  // necessary to pass a boolean true and not a string
            false: false,  // necessary to pass a boolean true and not a string
            waiting: false, // loading spinner
            important_message: '',
            system_message: '',
            error_message: '',
            modals: [],  // Dynamic modals
            openModals: 0,  // Dynamic modals counting
            unionScheduleModal: false,
            overridePenaltyModal: false,
            projectModal: false,
            batchModal: false,
            showHistory: false,
            buttonYesAction: [],
            buttonNoAction: [],
            button3Action: [],
            endpoints: {},
            hash: '',
            time_added: null,
            time_updated: null,
            user_can_approve: false,
            user_is_next_approver: false,
            user_is_final_approver: false,
            user_can_unlock: false,
            adminAccess: false,
            type: '', //employee or employer
            timecardType: undefined, // weekly (undefined), biweekly
            lastUpdated: '',
            timecardLayout: null, // default is regular, SAG and flat will have different layouts
            relatedTimecards: undefined,
            assignmentTotals: undefined,
            enableProBooks: false,
            probooksAccounts: '',
            probooksFreeFields: '',
            probooksSeries: '',
            probooksLocations: '',
            probooksSets: '',
            probooksProjects: '',
            enableApproveButton: false,
            excludeVacPay: false,
            locationChanged: false,

            // dynamic modal buttons
            button1: '',
            button2Label: 'OK',

            // statuses
            showDetails: false,
            showAllocation: false,
            showReviewBox: false,
            empLocked: false,
            perLocked: false,
            cardLocked: false,
            allowanceLocked: false,

            // Kickback timecard
            kickbackModal: false,
            kickbackApproverModal: false,
            kickbackApprovalId: null,
            adjustmentModal: false,
            employerMessage: '',

            // autocomplete
            selected_budget_code: '',
            selected_fringe_code: '',
            selected_free_field: '',
            selected_free_field2: '',
            selected_series_code: '',
            selected_location_code: '',
            selected_set_code: '',
            selected_pw_budget_code: '',
            selected_pw_fringe_code: '',
            selected_pw_free_field: '',
            selected_pw_free_field2: '',
            selected_pw_series_code: '',
            selected_pw_location_code: '',
            selected_pw_set_code: '',
            selected_kr_code: '',
            selected_kr_free_field: '',
            selected_kr_free_field2: '',
            selected_krtax_code: '',
            selected_krtax_free_field: '',
            selected_krtax_free_field2: '',
            selected_pd_code: '',
            selected_pd_free_field: '',
            selected_pd_free_field2: '',
            selected_pd_taxable_code: '',
            selected_pdtax_free_field: '',
            selected_pdtax_free_field2: '',
            selected_lodging_code: '',
            selected_lodging_free_field: '',
            selected_lodging_free_field2: '',
            selected_lodging_tax_code: '',
            selected_lodging_tax_free_field: '',
            selected_lodging_tax_free_field2: '',
            selected_pd_advance_code: '',
            selected_pdadv_free_field: '',
            selected_pdadv_free_field2: '',
            selected_mi_code: '',
            selected_mi_free_field: '',
            selected_mi_free_field2: '',
            selected_phone_allow_code: '',
            selected_phone_allow_free_field: '',
            selected_phone_allow_free_field2: '',
            selected_cr_code: '',
            selected_cr_free_field: '',
            selected_cr_free_field2: '',
            selected_agent_code: '',
            selected_agent_free_field: '',
            selected_agent_free_field2: '',

            // List of timecards to go back/forth
            timecardList: [],

            // employees/locations retrieved from database
            entity: {},
            entityData: [],
            employees: [],
            projectLocations: [],
            unionLocations: [],
            allProjects: [],
            assignedProjects: [],
            dayTypes: [],
            otherPayTypes: [],
            allowanceRateUnits: [],
            jobTitles: [],
            timecards: [],
            batches: [],
            employee: '',
            timecard_id: '',
            batch: '',
            batch_id: '',
            employee_status: '',
            employer_status: '',
            status: '',
            payroll_status: '',
            reviewed: '',
            statusFull: '',
            timezone_local: new Date().getTimezoneOffset(),
            timezone_entered: undefined,
            dates: [], // production schedule dates
            loadedTimes: {
                day_1: {
                    time_1: ''
                },
                day_2: {
                    time_1: ''
                },
                day_3: {
                    time_1: ''
                },
                day_4: {
                    time_1: ''
                },
                day_5: {
                    time_1: ''
                },
                day_6: {
                    time_1: ''
                },
                day_7: {
                    time_1: ''
                },
            }, // Way to import times into day

            // Assignment details
            assignment: {
                id: '',
                hash: '',
                department: '',
                department_id: '',
                entity_id: '',
                employee_id: '',
                loanout_status: '',
                rate: '',
                rate_unit: '',
                rate_unit_id: '',
                hourly_rate: '',
                rate_comment: '',
                guaranteed_hours: '',
                guaranteed_hours_unit: '',
                guaranteed_hours_unit_id: '',
                guaranteed_hours_6th: '',
                guaranteed_hours_7th: '',
                job_title: '',
                job_title_id: '',
                job_title_override: '',
                occ_code: '',
                flsa_type_id: '',
                legislative_type_id: '',
                legislative_type: '',
                currency_id: '',
                currency: '',
                rule_collection: '',
                rule_collection_id: '',
                scale_rate: null,
                scale_stn: null,
                union_local: 'NON-UNION',
                union_local_id: '',
                union_jurisdiction: '',
                union_jurisdiction_id: '',
                union_schedule: '',
                union_schedule_id: '',
                union_hired_from: '',
                union_hired_from_id: '',
                union_location: '',
                union_location_id: '',
                union_on_prod: '',
                union_on_prod_id: '',
                union_flsa_type_id: '',
                union_ruleset_id: '',
                union_rule_overrides: '',
                location: '',
                location_id: '',
                flat_payment: '',
                kit_rental: '',
                kit_rental_tax: '',
                per_diem: '',
                per_diem_taxable: '',
                lodging: '',
                lodging_tax: '',
                phone_allow: '',
                per_diem_advance: '',
                car_rental: '',
                other: '',
                mileage: '',
                budget_code: '',
                agent_fee: '',
                fringe_code: '',
                series_code: '',
                location_code: '',
                set_code: '',
                free_field: '',
                free_field2: '',
                kr_code: '',
                krtax_code: '',
                kit_rate_unit_id: '',
                phone_rate_unit_id: '',
                car_rate_unit_id: '',
                kit_rate_unit: '',
                phone_rate_unit: '',
                car_rate_unit: '',
                kr_cap: '',
                krtax_cap: '',
                pd_code: '',
                pd_rate_unit_id: '',
                pd_rate_unit: '',
                pd_taxable_code: '',
                lodging_code: '',
                lodging_tax_code: '',
                lodging_rate_unit_id: '',
                lodging_rate_unit: '',
                phone_allow_code: '',
                phone_cap: '',
                pd_advance_code: '',
                cr_code: '',
                cr_cap: '',
                mi_code: '',
                other_code: '',
                agent_code: '',
                kr_free_field: '',
                krtax_free_field: '',
                pd_free_field: '',
                pdtax_free_field: '',
                lodging_free_field: '',
                lodging_tax_free_field: '',
                phone_allow_free_field: '',
                pdadv_free_field: '',
                cr_free_field: '',
                mi_free_field: '',
                other_free_field: '',
                agent_free_field: '',
                kr_free_field2: '',
                krtax_free_field2: '',
                pd_free_field2: '',
                pdtax_free_field2: '',
                lodging_free_field2: '',
                lodging_tax_free_field2: '',
                phone_allow_free_field2: '',
                pdadv_free_field2: '',
                cr_free_field2: '',
                mi_free_field2: '',
                other_free_field2: '',
                agent_free_field2: '',
                kr_loc_type: '',
                krtax_loc_type: '',
                phone_loc_type: '',
                pd_loc_type: '',
                pd_taxable_loc_type: '',
                lodging_loc_type: '',
                lodging_tax_loc_type: '',
                cr_loc_type: '',
                kit_inventory_id: '',
                start_date: '',
                term_date: '',
                additional_allowances: {},
                metadata: {},
                work_day: 0,
            },

            employeeObject: undefined,

            exempt: false,

            // Store user input hours here. TODO move to veux
            week: {
                overrideDay7: null,
                day_1: { date: {short: ''}, day_type: 'nowork', project: '', project_id: '', account: {} },
                day_2: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_3: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_4: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_5: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_6: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_7: { date: {short: ''}, day_type: 'nowork', project: '', project_id: '', account: {} },
            },
            week2: {
                day_1: { date: {short: ''}, day_type: 'nowork', project: '', project_id: '', account: {} },
                day_2: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_3: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_4: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_5: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_6: { date: {short: ''}, day_type: 'worked', project: '', project_id: '', account: {} },
                day_7: { date: {short: ''}, day_type: 'nowork', project: '', project_id: '', account: {} },
            },

            employee_comments: '',
            employer_comments: '',
            payroll_comments: '',
            // Calendar opts:
            weekEnding: undefined,
            weekEndingTime: undefined,
            format: 'MM/dd/yyyy',
            clear: false,
            placeholder: 'Click to select week ending',
            // Dates for TC
            // Calc'd options
            brokenHours: { day_1: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_2: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_3: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_4: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_5: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_6: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_7: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, week: { allowances: {} } },
            brokenHours2: { day_1: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_2: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_3: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_4: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_5: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_6: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, day_7: {penalty_meal_1: {value: '', pay: ''}, penalty_meal_2: {value: '', pay: ''}}, week: { allowances: {} } },
            hours_worked: 0.00,

            defaultLocation: {},
            newWeekEnding: undefined,
            showProjects: undefined,
            showAssignedProjects: undefined,
            showAccountString: undefined,
            showOverrideMPs: undefined,
            showBatches: undefined,
            showOtherPay: false,
            otherPayModal: false,
            accountString: {},
            accruals: {
                sick: {
                    visible: false,
                    balance: '0.00'
                },
                vacation: {
                    visible: false,
                    balance: '0.00'
                },
                holiday: {
                    visible: false,
                    balance: '0.00'
                },
                covid_sick: {
                    visible: false,
                    balance: '4800.00'
                },
                covid_fmla: {
                    visible: false,
                    balance: '4800.00'
                }
            },
            previousTimecard: undefined,
            // Saved pay-allocation rows (restored from overrides.allocation); empty => the
            // Allocation component builds the default day-based split. See components/allocation.vue.
            allocation: [],
            allocationValid: true,

            // Document Uploads
            timecardDocModal: false,
            assets: [],

            // Dropzone Options
            dzoptions: {
                headers: { "Auth": authToken },
                acceptedFileTypes: ".txt,.pdf,.jpeg,.jpg,.heic,.png,.tif,.tiff,.doc,.docx,.xls,.xlsx",
                // acceptedFiles: 'text/plain,application/pdf,image/jpeg,image/png,image/gif,image/tiff,application/msword,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                maxFileSizeInMB: 5,
                uploadMultiple: true,
                maxNumberOfFiles: 5,
                showRemoveLink: false,
                thumbnailHeight: 20,
                thumbnailWidth: 20,
            },

            // New Batch
            newBatch: {
                name: '',
                description: '',
                department_id: '',
                signatory_name: '',
                is_union: '',
                status: 1,
            },

            // New Project
            newProject: {
                code: '',
                name: '',
                description: '',
                project_type_id: '1',
                signatory_number: '',
            },

            // New Other Pay Type
            newOtherPay: {
                name: '',
                code: '',
                type_id: null,
                description: '',
                pay: null,
                budget_code: null,
                fringe_code: null,
                series_code: null,
                location_code: null,
                set_code: null,
                free_field: null,
                free_field2: null,
            },

            // For overrides
            overrides: {
                mealPenalties: false,
                gross: false,
                kit_rental: {
                    daysWorked: null,
                    amount: null,
                },
                kit_rental_tax: {
                    daysWorked: null,
                    amount: null,
                },
                per_diem: {
                    daysWorked: null,
                    amount: null,
                },
                per_diem_taxable: {
                    daysWorked: null,
                    amount: null,
                },
                lodging: {
                    daysWorked: null,
                    amount: null,
                },
                lodging_tax: {
                    daysWorked: null,
                    amount: null,
                },
                car_rental: {
                    daysWorked: null,
                    amount: null,
                },
                phone_allow: {
                    daysWorked: null,
                    amount: null,
                },
                per_diem_advance: {
                    amount: null,
                },
                mileage: {
                    amount: null,
                },
            },

            // For adjustments
            adjusted: null,
            originalAssignmentObject: {},
            originalWeekObject: {},
            originalBrokenHoursObject: {},

            history: undefined,
            editBatch: {
                id: '',
                name: '',
                week_ending: '',
                description: '',
                department_id: '',
                signatory_name: '',
                is_union: '',
                status: ''
            },
            editBatchModal: false,
            isBatchChanged: false,
            departments: [],
            countIdle: 0,
            countStudio: 0,
            countDistant: 0,
            totalWorkDays: 0,
            countStudioPlusIdle: 0,
            countDistantPlusIdle: 0,
            totalWorkPlusIdleDays: 0,
            allowanceMessage: '',
            reviews: [],
            defaultLaborSubtotal: false,
            calculatedLaborSubtotal: false,
            additionalBreakouts: false,
            calculatedBreakouts: false,
            useSignatories: false,
            signatories: [],
            previousApprovals: [],
        }
    },

    computed: {
        getAssignmentRate() {
            return this.assignment.rate;
        },
        getAssignmentRateComment() {
            return this.assignment.rate_comment;
        },
        getAssignmentRateUnit() {
            return this.assignment.rate_unit;
        },
        getAssignmentHourlyRate() {
            return this.assignment.hourly_rate;
        },
        getAssignmentGuaranteedHours() {
            return this.assignment.guaranteed_hours;
        },
        getAssignmentGuaranteedHoursUnit() {
            return this.assignment.guaranteed_hours_unit;
        },
        getAssignmentScaleRate() {
            return this.assignment.scale_rate;
        },
        getAssignmentLegislativeType() {
            return this.assignment.legislative_type;
        },
        newBatchWeekEnding() {
            // we have two cases for weekEnding. one is for 04/13/2024, another one is 2024-04-13T-----. but we want to see MM/DD/YYYY format
            let weekEndingLen = this.weekEnding.split('T').length;
            if (weekEndingLen > 1) {
                let splitDate =  this.weekEnding.split('T')[0].split('-');
                return splitDate[1]+'/'+splitDate[2]+'/'+splitDate[0];
            } else {
                return this.weekEnding.split('T')[0];
            }
        },
        disabled() {
            let days;
            const weekEndingDay = this.entity.week_ending;
            switch (weekEndingDay) {
                case 'Sunday':
                    days = [1, 2, 3, 4, 5, 6];
                    break;

                case 'Monday':
                    days = [0, 2, 3, 4, 5, 6];
                    break;

                case 'Tuesday':
                    days = [0, 1, 3, 4, 5, 6];
                    break;

                case 'Wednesday':
                    days = [0, 1, 2, 4, 5, 6];
                    break;

                case 'Thursday':
                    days = [0, 1, 2, 3, 5, 6];
                    break;

                case 'Friday':
                    days = [0, 1, 2, 3, 4, 6];
                    break;

                default:
                    days = [0, 1, 2, 3, 4, 5];
            }

            return days;
        },
        getPrepStartDay() {
            return this.entity.prep_start_date;
        },
        getPrepEndDay() {
            return this.entity.prep_end_date;
        },
        getWrapStartDay() {
            return this.entity.post_start_date;
        },
        getWrapEndDay() {
            return this.entity.post_end_date;
        },
        timezone_offset() {
            return this.timezone_entered === undefined || this.timezone_entered === null ? this.timezone_local : this.timezone_entered;
        },
        total_hours_straight() {
            const buckets = [ 'pay_straight', 'pay_straight_other2' ];
            let hours = 0;
            for (const b of buckets) {
                const bucket = this.getHoursByBucket(b);
                hours += (bucket && !isNaN(bucket)) ? parseFloat(bucket) : 0;
            }
            return hours.toFixed(2);
        },
        total_hours_ot_15() {
            return this.getHoursByBucket('pay_ot_15');
        },
        total_hours_ot_2() {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_2')) + parseFloat(this.getHoursByBucket('pay_ot_2_other')));
        },
        total_hours_ot_25() {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_25')) + parseFloat(this.getHoursByBucket('pay_ot_25_other')));
        },
        total_hours_ot_3() {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_3')) + parseFloat(this.getHoursByBucket('pay_ot_3_other')));
        },
        total_hours_ot_4() {
            return this.getHoursByBucket('pay_ot_4');
        },
        total_hours_ot_5() {
            return this.getHoursByBucket('pay_ot_5');
        },
        total_hours_ot_345 () {
            return this.round(parseFloat(this.total_hours_ot_3) + parseFloat(this.total_hours_ot_4) + parseFloat(this.total_hours_ot_5) );
        },
        total_hours_ot_15_gold () {
            return this.getHoursByBucket('pay_ot_15_gold');
        },
        total_hours_ot_2_gold () {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_2_gold')) + parseFloat(this.getHoursByBucket('pay_ot_2_other_gold')));
        },
        total_hours_ot_25_gold () {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_25_gold')) + parseFloat(this.getHoursByBucket('pay_ot_25_other_gold')));
        },
        total_hours_ot_3_gold () {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_3_gold')) + parseFloat(this.getHoursByBucket('pay_ot_3_other_gold')));
        },
        total_hours_ot_4_gold () {
            return this.getHoursByBucket('pay_ot_4_gold');
        },
        total_hours_ot_45_gold () {
            return this.getHoursByBucket('pay_ot_45_gold');
        },
        total_hours_ot_5_gold () {
            return this.getHoursByBucket('pay_ot_5_gold');
        },
        total_hours_ot_6_gold () {
            return this.getHoursByBucket('pay_ot_6_gold');
        },
        total_hours_ot_345_gold () {
            return this.round(parseFloat(this.total_hours_ot_3_gold) + parseFloat(this.total_hours_ot_4_gold) + parseFloat(this.total_hours_ot_5_gold) );
        },
        total_hours_straight_forced () {
            return this.getHoursByBucket('pay_straight_forced');
        },
        total_hours_ot_15_forced () {
            return this.getHoursByBucket('pay_ot_15_forced');
        },
        total_hours_ot_2_forced () {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_2_forced')) + parseFloat(this.getHoursByBucket('pay_ot_2_other_forced')));
        },
        total_hours_ot_25_forced () {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_25_forced')) + parseFloat(this.getHoursByBucket('pay_ot_25_other_forced')));
        },
        total_hours_ot_3_forced () {
            return this.round(parseFloat(this.getHoursByBucket('pay_ot_3_forced')) + parseFloat(this.getHoursByBucket('pay_ot_3_other_forced')));
        },
        total_hours_ot_4_forced () {
            return this.getHoursByBucket('pay_ot_4_forced');
        },
        total_hours_ot_5_forced () {
            return this.getHoursByBucket('pay_ot_5_forced');
        },
        total_hours_ot_345_forced () {
            return this.round(parseFloat(this.total_hours_ot_3_forced) + parseFloat(this.total_hours_ot_4_forced) + parseFloat(this.total_hours_ot_5_forced) );
        },
        total_hours_ot_15_gold_forced () {
            return this.getHoursByBucket('pay_ot_15_gold_forced');
        },
        total_hours_ot_2_gold_forced () {
            return this.getHoursByBucket('pay_ot_2_gold_forced');
        },
        total_hours_ot_25_gold_forced () {
            return this.getHoursByBucket('pay_ot_25_gold_forced');
        },
        total_hours_ot_3_gold_forced () {
            return this.getHoursByBucket('pay_ot_3_gold_forced');
        },
        total_hours_ot_4_gold_forced () {
            return this.getHoursByBucket('pay_ot_4_gold_forced');
        },
        total_hours_ot_5_gold_forced () {
            return this.getHoursByBucket('pay_ot_5_gold_forced');
        },
        total_hours_ot_345_gold_forced () {
            return this.round(parseFloat(this.total_hours_ot_3_gold_forced) + parseFloat(this.total_hours_ot_4_gold_forced) + parseFloat(this.total_hours_ot_5_gold_forced) );
        },
        total_hours_ot() {
            return this.getHoursByBucketMatch(/^pay_ot/);
        },
        total_hours_gold() {
            return this.getHoursByBucketMatch(/^pay_.*gold$/);
        },
        total_hours_forced() {
            return this.getHoursByBucketMatch(/^pay_.*forced$/);
        },
        total_hours_ot_other() {
            let hours = parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_.*ot/)).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_ot_15).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_ot_2).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_ot_25).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_ot_3).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_ot_4).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_ot_5).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_gold).toFixed(4))
                - parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_.*straight_other/)).toFixed(4))
                - parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_.*ot.*_forced/)).toFixed(4))
                - parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_travel.*ot.*/)).toFixed(4))
                - parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_holiday.*ot.*/)).toFixed(4))
            ;
            return this.round(hours);
        },
        total_hours_ot_other_emp() {
            let hours = parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_.*ot/)).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_ot_15).toFixed(4))
                - parseFloat(parseFloat(this.total_hours_ot_2).toFixed(4))
            ;
            return this.round(hours);
        },
        total_hours_flsa() {
            let hours = parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_flsa/)).toFixed(4));
            return this.round(hours);
        },
        total_hours_invaded() {
            let invaded = 0;
            for (const i in this.brokenHours) {
                Object.keys(this.brokenHours[i]).map(val => {
                    if (val === 'invaded') invaded += parseInt(this.brokenHours[i][val]);
                });
            }

            if (this.timecardType === 'biweekly' && this.brokenHours2) {
                for (const i in this.brokenHours2) {
                    Object.keys(this.brokenHours2[i]).map(val => {
                        if (val === 'invaded') invaded += parseInt(this.brokenHours2[i][val]);
                    });
                }
            }
            if (invaded) invaded /= 60;
            return this.round(invaded);

        },
        total_hours_idle() {
            return this.getHoursByBucketMatch(/^pay_idle/);
        },
        total_hours_holiday() {
            let hours = parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_holiday/)).toFixed(4))
                - parseFloat(parseFloat(this.getHoursByBucketMatch(/^pay_holiday.*forced/)).toFixed(4))
            ;
            return this.round(hours);
        },
        total_hours_travel() {
            return this.getHoursByBucketMatch(/^pay_travel/);
        },
        total_hours() {
            return this.getHoursByBucket('total');
        },
        total_penalty_meal_1() {
            return this.getPayByBucket('penalty_meal_1');
        },
        total_penalty_meal_2() {
            return this.getPayByBucket('penalty_meal_2');
        },
        total_rest() {
            return this.getPayByBucket('rest');
        },
        total_penalties() {
            return this.getValueByBucket('penalties');
        },
        total_accrued() {
            return this.getValueByBucket('accrued');
        },
        total_premium() {
            return this.getValueByBucket('premium');
        },
        total_hours_accruals() {
            return this.getHoursByBucket('accruals');
        },
        total_pay_straight() {
            const buckets = [ 'pay_straight', 'pay_straight_other', 'pay_straight_other2' ];
            let pay = 0;
            for (const b of buckets) {
                const bucket = this.getPayByBucket(b);
                pay += (bucket && !isNaN(bucket)) ? parseFloat(bucket) : 0;
            }
            return pay.toFixed(2);
        },
        total_pay_ot_15() {
            return this.getPayByBucket('pay_ot_15');
        },
        total_pay_ot_2() {
            return (parseFloat(this.getPayByBucket('pay_ot_2')) + parseFloat(this.getPayByBucket('pay_ot_2_other'))).toFixed(2);
        },
        total_pay_ot_25() {
            return (parseFloat(this.getPayByBucket('pay_ot_25')) + parseFloat(this.getPayByBucket('pay_ot_25_other'))).toFixed(2);
        },
        total_pay_ot_3() {
            return (parseFloat(this.getPayByBucket('pay_ot_3')) + parseFloat(this.getPayByBucket('pay_ot_3_other'))).toFixed(2);
        },
        total_pay_ot_4() {
            return this.getPayByBucket('pay_ot_4');
        },
        total_pay_ot_5() {
            return this.getPayByBucket('pay_ot_5');
        },
        total_pay_ot_15_gold() {
            return this.getPayByBucket('pay_ot_15_gold');
        },
        total_pay_ot_2_gold() {
            return (parseFloat(this.getPayByBucket('pay_ot_2_gold')) + parseFloat(this.getPayByBucket('pay_ot_2_other_gold'))).toFixed(2);
        },
        total_pay_ot_25_gold() {
            return (parseFloat(this.getPayByBucket('pay_ot_25_gold')) + parseFloat(this.getPayByBucket('pay_ot_25_other_gold'))).toFixed(2);
        },
        total_pay_ot_3_gold() {
            return (parseFloat(this.getPayByBucket('pay_ot_3_gold')) + parseFloat(this.getPayByBucket('pay_ot_3_other_gold'))).toFixed(2);
        },
        total_pay_ot_4_gold() {
            return this.getPayByBucket('pay_ot_4_gold');
        },
        total_pay_ot_45_gold() {
            return this.getPayByBucket('pay_ot_45_gold');
        },
        total_pay_ot_5_gold() {
            return this.getPayByBucket('pay_ot_5_gold');
        },
        total_pay_ot_6_gold() {
            return this.getPayByBucket('pay_ot_6_gold');
        },
        total_pay_straight_forced() {
            return this.getPayByBucket('pay_straight_forced');
        },
        total_pay_ot_15_forced() {
            return this.getPayByBucket('pay_ot_15_forced');
        },
        total_pay_ot_2_forced() {
            return (parseFloat(this.getPayByBucket('pay_ot_2_forced')) + parseFloat(this.getPayByBucket('pay_ot_2_other_forced'))).toFixed(2);
        },
        total_pay_ot_25_forced() {
            return (parseFloat(this.getPayByBucket('pay_ot_25_forced')) + parseFloat(this.getPayByBucket('pay_ot_25_other_forced'))).toFixed(2);
        },
        total_pay_ot_3_forced() {
            return (parseFloat(this.getPayByBucket('pay_ot_3_forced')) + parseFloat(this.getPayByBucket('pay_ot_3_other_forced'))).toFixed(2);
        },
        total_pay_ot_4_forced() {
            return this.getPayByBucket('pay_ot_4_forced');
        },
        total_pay_ot_5_forced() {
            return this.getPayByBucket('pay_ot_5_forced');
        },
        total_pay_ot_15_gold_forced() {
            return this.getPayByBucket('pay_ot_15_gold_forced');
        },
        total_pay_ot_2_gold_forced() {
            return this.getPayByBucket('pay_ot_2_gold_forced');
        },
        total_pay_ot_25_gold_forced() {
            return this.getPayByBucket('pay_ot_25_gold_forced');
        },
        total_pay_ot_3_gold_forced() {
            return this.getPayByBucket('pay_ot_3_gold_forced');
        },
        total_pay_ot_4_gold_forced() {
            return this.getPayByBucket('pay_ot_4_gold_forced');
        },
        total_pay_ot_5_gold_forced() {
            return this.getPayByBucket('pay_ot_5_gold_forced');
        },
        total_pay_ot() {
            return this.getPayByBucketMatch(/^pay_.*ot/);
        },
        total_pay_gold() {
            return this.getPayByBucketMatch(/^pay_.*gold/);
        },
        total_pay_forced() {
            return this.getPayByBucketMatch(/^pay_.*forced/);
        },
        total_pay_ot_other() {
            let pay = 
                parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_.*ot/)).toFixed(4))
                - parseFloat(parseFloat(this.total_pay_ot_15).toFixed(4))
                - parseFloat(parseFloat(this.total_pay_ot_2).toFixed(4))
                - parseFloat(parseFloat(this.total_pay_ot_25).toFixed(4))
                - parseFloat(parseFloat(this.total_pay_ot_3).toFixed(4))
                - parseFloat(parseFloat(this.total_pay_ot_4).toFixed(4))
                - parseFloat(parseFloat(this.total_pay_ot_5).toFixed(4))
                - parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_.*straight_other/)).toFixed(4))
                - parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_.*ot.*_forced/)).toFixed(4))
                - parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_.*gold/)).toFixed(4))
                - parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_travel.*ot.*/)).toFixed(4))
                - parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_holiday.*ot.*/)).toFixed(4))
            ;
            // OT can never be less than $0.08 so any small amount is a result of us a rounding error.  Zero out.
            if (Math.abs(pay) <= 0.02) pay = 0;
            return this.round(pay);
        },
        total_pay_ot_other_emp() {
            let pay = parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_.*ot/)).toFixed(4))
                - parseFloat(parseFloat(this.total_pay_ot_15).toFixed(4))
                - parseFloat(parseFloat(this.total_pay_ot_2).toFixed(4))
            ; 

            // OT can never be less than $0.08 so any small amount is a result of us a rounding error.  Zero out.
            if (Math.abs(pay) <= 0.02) pay = 0;
            return this.round(pay);
        },
        total_pay_flsa() {
            return this.getPayByBucketMatch(/^pay_flsa/);
        },
        total_pay_allowances() {
            return this.getPayByBucket('allowances', true);
        },
        total_pay_penalties() {
            return this.getPayByBucket('penalties');
        },
        total_pay_premium() {
            return this.getPayByBucket('premium');
        },
        total_pay_accruals() {
            return this.getPayByBucket('accruals');
        },
        total_pay_idle() {
            return this.getPayByBucketMatch(/^pay_idle/);
        },
        total_pay_holiday() {
            let pay = parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_holiday/)).toFixed(4))
                - parseFloat(parseFloat(this.getPayByBucketMatch(/^pay_holiday.*forced/)).toFixed(4))
            ; 

            return this.round(pay);
        },
        total_pay_travel() {
            return this.getPayByBucketMatch(/^pay_travel/);
        },
        total_pay_agent_fees() {
            return this.getPayByBucket('agent_fee');
        },
        total_pay() {
            if (this.excludeVacPay) {
                return (parseFloat(this.getPayByBucket('total') || '0') - parseFloat(this.getPayByBucket('pay_vacation') || '0')).toFixed(4);
            } else {
                return this.getPayByBucket('total');
            }
        },
        total_accrued() {
            return this.getPayByBucket('accrued');
        },
        total_pay_vacation() {
            return this.getPayByBucket('pay_vacation');
        },
        total_accrued_holiday() {
            return this.getPayByBucket('accrued_holiday');
        },
        alternateStarts() {
            if (this.assignment.employee_id) {
                if (type === 'employee') {
                    // Need to make sure to limit to the current project here as the employee API returns all job data
                    if (this.assignment.union_local_id) {
                        // union
                        return employees.filter(employee => 
                            employee.employee_id == this.assignment.employee_id &&
                            employee.flsa_type_id == this.assignment.flsa_type_id &&
                            employee.union_flsa_type_id == this.assignment.union_flsa_type_id &&
                            employee.union_local_id == this.assignment.union_local_id &&
                            employee.status > 0 && parseInt(employee.entity_id) === parseInt(this.assignment.entity_id)
                        );
                    } else {
                        // non-union
                        return employees.filter(employee => 
                            employee.employee_id == this.assignment.employee_id &&
                            employee.flsa_type_id == this.assignment.flsa_type_id &&
                            employee.status > 0 && parseInt(employee.entity_id) === parseInt(this.assignment.entity_id)
                        );
                    }
                } else {
                    return this.employees.filter(( {employee_id} ) => { return (employee_id == this.assignment.employee_id) } );
                }
            } else {
                return undefined;
            }
        },
        rateObject() {
            if (this.assignment.rate) {
                return {
                    rate: this.assignment.rate,
                    rate_unit: this.assignment.rate_unit,
                    rate_unit_id: this.assignment.rate_unit_id,
                    rate_comment: this.assignment.rate_comment,
                    hourly_rate: this.assignment.hourly_rate
                };
            } else {
                return {
                    rate: null,
                    rate_unit: null,
                    rate_unit_id: null,
                    rate_comment: null,
                    hourly_rate: null
                };
            }
        },
        filteredDayTypes() {
            if (this.dayTypes.length < 1) return [];

            return this.dayTypes.filter(({ exempt, nonexempt, union, nonunion, agreement_id, union_local_id, legislative_type_id, currency_id }) => {
                // Union
                if (this.assignment.agreement_id || this.assignment.union_local_id) {
                    return (legislative_type_id === null || legislative_type_id == this.assignment.legislative_type_id) && (currency_id === null || currency_id == this.assignment.currency_id) && (agreement_id == this.assignment.agreement_id || union_local_id == this.assignment.union_local_id || (union == 1 && union_local_id === null && agreement_id === null));

                // Exempt US
                } else if (this.assignment.flsa_type_id == 2) {
                    return (legislative_type_id === null || legislative_type_id == this.assignment.legislative_type_id) && (currency_id === null || currency_id == this.assignment.currency_id) && (exempt == 1 && nonunion == 1);

                // Default to non-union
                } else {
                    return (currency_id === null || currency_id == this.assignment.currency_id) && (nonexempt == 1 && nonunion == 1);
                }
            });
        },
        nextTimecard () {
            const current = this.timecardList.indexOf(this.hash) || null;
            let next;

            if (current >= 0) {
                next = current + 1;
                return this.timecardList[next];
            } else {
                return next;
            }
        },
        prevTimecard () {
            const current = this.timecardList.indexOf(this.hash) || null;
            let next;

            if (current > 0) {
                next = current - 1;
                return this.timecardList[next];
            } else {
                return next;
            }
        },
        openBatches () {
            if (! this.batches || !Array.isArray(this.batches) || this.batches.length === 0) {
                return [];
            } else {
                return this.batches.filter(({id, status}) => parseInt(status) === 1 || parseInt(id) === parseInt(this.batch_id))
            }
        },
        // we will not use this function as requested but keep this bc we might need this later.
        isEmployeeSigned() {
            return this.employee_status > 0 ? true : false;
        },
        currentAdditionalAllowances() {
            if (typeof this.assignment.additional_allowances === 'object') {
                return this.assignment.additional_allowances;
            } else {
                return null;
            }
        },
        daily_comments() {
            let comments = '';
            for (const i in this.week) {
                if (i && !i.match(/^day_/)) continue;
                const day = this.week[i];
                if (day.employer_comments || day.employee_comments) {
                    comments += day.date.short + ': ';
                    comments += day.employer_comments ? ' ER: ' + day.employer_comments + "\n" : '';
                    comments += day.employee_comments ? ' EE: ' + day.employee_comments + "\n" : '';
                }
            }
            if (this.timecardType === 'biweekly') {
                for (const i in this.week2) {
                    if (i && !i.match(/^day_/)) continue;
                    const day = this.week2[i];
                    if (day.employer_comments || day.employee_comments) {
                        comments += day.date.short + ': ';
                        comments += day.employer_comments ? ' ER: ' + day.employer_comments + "\n" : '';
                        comments += day.employee_comments ? ' EE: ' + day.employee_comments + "\n" : '';
                    }
                }
            }
            return comments;
        },
        showRelatedTimecards() {
            if (this.relatedTimecards && Array.isArray(this.relatedTimecards) && this.relatedTimecards.length > 0) {
                for (const i in this.relatedTimecards) {
                    const tc = this.relatedTimecards[i];
                    if (tc && tc.status > 0 && tc.entity_id !== this.assignment.entity_id) {
                        return true;
                    } else {
                        return false;
                    }
                }
            } else {
                return false;
            }
        },
        daysWorked() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            return this.totalWorkDays;
        },
        daysWorkedKit() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            if (this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.krDaysWorked) {
                return this.brokenHours.week.allowances.krDaysWorked;
            } else {
                return null;
            }
        },
        daysWorkedKitTax() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            if (this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.krTaxDaysWorked) {
                return this.brokenHours.week.allowances.krTaxDaysWorked;
            } else {
                return null;
            }
        },
        daysWorkedPhone() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            if (this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.phoneDaysWorked) {
                return this.brokenHours.week.allowances.phoneDaysWorked;
            } else {
                return null;
            }
        },
        daysWorkedPerDiem() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            if (this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.pdDaysWorked) {
                return this.brokenHours.week.allowances.pdDaysWorked;
            } else {
                return null;
            }
        },
        daysWorkedPerDiemTax() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            if (this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.pdTaxableDaysWorked) {
                return this.brokenHours.week.allowances.pdTaxableDaysWorked;
            } else {
                return null;
            }
        },
        daysWorkedLodging() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            if (this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.lodgingDaysWorked) {
                return this.brokenHours.week.allowances.lodgingDaysWorked;
            } else {
                return null;
            }
        },
        daysWorkedLodgingTax() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            if (this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.lodgingTaxDaysWorked) {
                return this.brokenHours.week.allowances.lodgingTaxDaysWorked;
            } else {
                return null;
            }
        },
        daysWorkedCar() {
            if (!this.brokenHours.week.hasOwnProperty('total')) return null;
            if (this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.crDaysWorked) {
                return this.brokenHours.week.allowances.crDaysWorked;
            } else {
                return null;
            }
        },
        daysWorkedOverrideKit() {
            return (((this.overrides || {}).kit_rental || {}).daysWorked) || null;
        },
        daysWorkedOverrideKitTax() {
            return (((this.overrides || {}).kit_rental_tax || {}).daysWorked) || null;
        },
        daysWorkedOverridePhone() {
            return (((this.overrides || {}).phone_allow || {}).daysWorked) || null;
        },
        daysWorkedOverridePerDiem() {
            return (((this.overrides || {}).per_diem || {}).daysWorked) || null;
        },
        daysWorkedOverrideLodging() {
            return (((this.overrides || {}).lodging || {}).daysWorked) || null;
        },
        daysWorkedOverrideCar() {
            return (((this.overrides || {}).car_rental || {}).daysWorked) || null;
        },
        isCanada() {
            return (parseInt(this.assignment.currency_id) === 2)
        },
        isI9Needed() {
            const mainLocation = (this.projectLocations || []).find((loc) => parseInt(loc.id) === parseInt(this.assignment.location_id));
            if (parseInt(this.assignment.loanout_status > 0)) {
                return false;
            } else if (mainLocation && parseInt(mainLocation.country_id) > 1) {
                return false;
            } else {
                return true;
            }
        },
        formatted_week_ending() {
            return typeof this.weekEndingTime === 'object' ? this.weekEndingTime.toISOString().substr(0, 10) : this.weekEndingTime.substr(0, 10);
        },
        latestReview() {
            if (this.reviews && this.reviews.length) {
                const review = this.reviews.slice(-1)[0];
                let result = review.comments || '';
                result += review.review_type ? ` (${review.review_type})` : '';
                result += review.user ? ` by ${review.user}` : '';
                return result || 'None';
            } else {
                return 'None';
            }
        },

        // Customization to add subtotal labor lines independent of items like vacation or travel pay.
        laborSubtotal() {
            const fields = this.assignment.laborSubtotal || this.defaultLaborSubtotal || false;
            let hours = 0;
            let pay = 0;

            if (!fields) {
                return null;
            }

            if (fields.paycodes) {
                fields.paycodes.forEach((code) => {
                    pay += parseFloat(this.getPayByBucketMatch(code));
                    hours += parseFloat(this.getHoursByBucketMatch(code));
                    // console.log(`Adding ${parseFloat(this.getPayByBucketMatch(code))} to ${code}`);
                    // console.log(`Adding ${parseFloat(this.getHoursByBucketMatch(code))} to ${code}`);
                });
            }

            if (fields.allowances) {
                for (const allowance in fields.allowances) {
                    // Default is to reduce only the total
                    const options = fields.allowances[allowance];
                    const reduce = options && options.reduceAllowances === false ? false : true;

                    // Normal allowances
                    if (this.brokenHours.week.allowances[allowance]) {
                        const amount = parseFloat(this.brokenHours.week.allowances[allowance]);
                        pay += amount;
                        // console.log(`Adding ${amount} to ${allowance}`);
                        if (this.calculatedLaborSubtotal === false && reduce) {
                            // console.log('Reducing allowance by ' + this.brokenHours.week.allowances[allowance] + ' ' + this.brokenHours.week.allowances.pay + ' ' + amount);
                            this.brokenHours.week.allowances.pay -= amount;
                        }
                    }

                    // Additional Allowances
                    if (this.currentAdditionalAllowances) {
                        for (const i in this.currentAdditionalAllowances) {
                            if (this.currentAdditionalAllowances[i].code && this.currentAdditionalAllowances[i].code === allowance) {
                                const amount = parseFloat(this.currentAdditionalAllowances[i].pay || '0');
                                pay += amount;
                                // console.log(`Adding ${pay} to ${allowance}`);
                                if (this.calculatedLaborSubtotal === false && reduce) {
                                    // console.log('Reducing other allowance by ' + this.currentAdditionalAllowances[i].pay + ' ' + this.brokenHours.week.allowances.pay + ' ' + + amount);
                                    this.brokenHours.week.allowances.pay -= amount;
                                }
                            }
                        }
                    }
                }
            }

            if (pay && pay > 0) this.calculatedLaborSubtotal = true;
            return {
                pay: pay.toFixed(2),
                hours: hours.toFixed(2),
            };
        },

        // Customization to add other pay to the timecard summary.
        summaryBreakouts() {
            const breakouts = Object.assign([], this.assignment.additionalBreakouts || this.additionalBreakouts || false);
            let counter = 0;

            // Add up pay amounts
            if (breakouts && Array.isArray(breakouts)) {
                breakouts.forEach((res) => {
                    const reduce = res.reduceAllowances === false ? false : true;
                    // console.log('Reduce for ' + res.label + ': ' + reduce);
                    res.pay = 0;

                    // Additional Allowances
                    if (this.currentAdditionalAllowances) {
                        for (const i in this.currentAdditionalAllowances) {
                            if (this.currentAdditionalAllowances[i].code && res.allowances.includes(this.currentAdditionalAllowances[i].code)) {
                                const amount = parseFloat(this.currentAdditionalAllowances[i].pay || '0');
                                res.pay += amount;
                                counter++;
                                // console.log(`Adding ${res.pay} to ${res.label}`);
                                if (this.calculatedBreakouts === false && reduce) {
                                    // this.currentAdditionalAllowances[i].pay -= amount;
                                    this.brokenHours.week.allowances.pay -= amount;
                                    // console.log('Reducing other allowance by ' + amount + ' for ' + i.code);
                                }
                            }
                        }
                    }
                    res.pay = res.pay.toFixed(2);
                });
            } else {
                return false;
            }
            
            if (counter > 0) this.calculatedBreakouts = true;
            return breakouts;
        },

        preLaborBreakouts() {
            if (!this.summaryBreakouts) return false;
            const result = this.sortObjectByProperty(this.summaryBreakouts.filter((b) => parseFloat(b.pay || 0) !== 0 && parseInt(b.sortOrder) < 100), 'sort_order');
            if (!result || !Array.isArray(result) || result.length === 0) {
                return false;
            }
            return result;
        },

        postLaborBreakouts() {
            if (!this.summaryBreakouts) return false;
            const result = this.sortObjectByProperty(this.summaryBreakouts.filter((b) => parseFloat(b.pay || 0) !== 0 && parseInt(b.sortOrder) >= 100), 'sort_order');
            if (!result || !Array.isArray(result) || result.length === 0) {
                return false;
            }
            return result;
        },

        // Only show signatories with names
        filteredSignatories() {
            if (!this.signatories || !Array.isArray(this.signatories)) return [];
            return this.signatories.filter((sig) => sig.name);
        },

        showProjectLocation() {
            return this.projectLocations && Array.isArray(this.projectLocations) && this.projectLocations.length > 0;
        },

        projects() {
            if (this.showAssignedProjects && this.assignedProjects && Array.isArray(this.assignedProjects)) {
                return this.assignedProjects;
            } else {
                return this.allProjects;
            }
        },
    },

    methods: {
        checkAllowanceMessage() {
            let isKitOverride = false;
            let isKitTaxOverride = false;
            let isPhoneOverride = false;
            let isPdOverride = false;
            let isPdTaxOverride = false;
            let isLodgingOverride = false;
            let isLodgingTaxOverride = false;
            let isCarOverride = false;

            if (this.overrides && this.overrides.kit_rental && (this.overrides.kit_rental.daysWorked || this.overrides.kit_rental.amount)) isKitOverride = true;
            if (this.overrides && this.overrides.kit_rental_tax && (this.overrides.kit_rental_tax.daysWorked || this.overrides.kit_rental_tax.amount)) isKitTaxOverride = true;
            if (this.overrides && this.overrides.phone_allow && (this.overrides.phone_allow.daysWorked || this.overrides.phone_allow.amount)) isPhoneOverride = true;
            if (this.overrides && this.overrides.per_diem && (this.overrides.per_diem.daysWorked || this.overrides.per_diem.amount)) isPdOverride = true;
            if (this.overrides && this.overrides.per_diem_taxable && (this.overrides.per_diem_taxable.daysWorked || this.overrides.per_diem_taxable.amount)) isPdTaxOverride = true;
            if (this.overrides && this.overrides.lodging && (this.overrides.lodging.daysWorked || this.overrides.lodging.amount)) isLodgingOverride = true;
            if (this.overrides && this.overrides.lodging_tax && (this.overrides.lodging_tax.daysWorked || this.overrides.lodging_tax.amount)) isLodgingTaxOverride = true;
            if (this.overrides && this.overrides.car_rental && (this.overrides.car_rental.daysWorked || this.overrides.car_rental.amount)) isCarOverride = true;

            let total = 0;
            let totalPlusIdle = 0;

            if (this.brokenHours && this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.totalDays) total = this.brokenHours.week.allowances.totalDays;
            if (this.brokenHours && this.brokenHours.week && this.brokenHours.week.allowances && this.brokenHours.week.allowances.totalPlusIdleDays) totalPlusIdle = this.brokenHours.week.allowances.totalPlusIdleDays;

            if ( !isKitOverride && (this.daysWorkedKit < total) || !isKitTaxOverride && (this.daysWorkedKitTax < total) || !isPhoneOverride && (this.daysWorkedPhone < totalPlusIdle) || !isPdOverride && (this.daysWorkedPerDiem < totalPlusIdle) || !isPdTaxOverride && (this.daysWorkedPerDiemTax < totalPlusIdle) || !isLodgingOverride && (this.daysWorkedLodging < totalPlusIdle) || !isLodgingTaxOverride && (this.daysWorkedLodgingTax < totalPlusIdle) || !isCarOverride && (this.daysWorkedCar < totalPlusIdle)) {
                if (!this.allowanceMessage) {
                    this.allowanceMessage = 'Allowances set up for a specific location type will only calculate on dates matching the location type.<br />';
                }
            } else {
                if (this.allowanceMessage) this.allowanceMessage = '';
            }
        },
        async openEditBatchModal(batchId) {
            let response = await this.oasisApi.get(`/batches/${batchId}`);
            if (response && response.data && response.data.results.length > 0) {
                // we expect that we can always get this data as long as our system is not down.
                this.editBatch.id = this.batch_id;
                this.editBatch.name = response.data.results[0].name; // requried field
                this.editBatch.description = response.data.results[0].description ? response.data.results[0].description : '';
                this.editBatch.week_ending = this.parseLuxon(response.data.results[0].week_ending).toFormat(this.format); // requried field
                this.editBatch.department_id = response.data.results[0].department_id ? response.data.results[0].department_id : '';
                this.editBatch.union_local_id = response.data.results[0].union_local_id ? response.data.results[0].union_local_id : '';
                this.editBatch.status = response.data.results[0].status;
                this.editBatch.is_union = response.data.results[0].is_union == 1 ? true : false;
                this.editBatch.signatory_name = response.data.results[0].signatory_name ? response.data.results[0].signatory_name : '';
            }
            this.editBatchModal = true;
        },
        async editBatchInfo() {
            if (this.checkForm("#editBatchForm")) {
                if (this.isBatchChanged) {
                    let method = 'patch';

                    // only three values can be changed. - name, description, department_id
                    let data = {id: this.editBatch.id, entity_id: entityId, name: this.editBatch.name.trim(), description: this.editBatch.description, department_id: this.editBatch.department_id ? this.editBatch.department_id : null};
                    this.oasisApi[method](`/batches/${this.editBatch.id}`, data)
                        .then(response => {
                            if (response.status == 200 || response.status == 201) {
                                this.editBatchModal = false;
                                if (response.data.count === 1) {
                                    return response.data.results[0];
                                }
                                else return false;
                            } else if (response.status == 400 || response.status == 422) {
                                if (Array.isArray(response.data.errorMessages)) {
                                    const errorMessages = response.data.errorMessages;
                                    let message = '';
                                    for (const i in errorMessages) {
                                        if (typeof errorMessages[i].message !== 'string') continue;
                                        $("#editBatchForm input[name='" + errorMessages[i].field + "']").addClass('form-error2');
                                        message += (errorMessages[i].message + "\n") || '';
                                    }
                                    this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                                } else {
                                    this.createDialog({ "title": "Error", "body": response.data.message || 'Error editing the field.', "buttonNo": false, "buttonYesLabel": "OK" });
                                }
                                return false;
                            } else {
                                this.createDialog({ "title": "Alert", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                                return false;
                            }
                        })
                        .then(async (result) => {
                            if (!result) return false;
                            // Refresh
                            await this.getBatches();
                            this.isBatchChanged = false;
                        })
                        .catch(error => {
                            console.log('error: '); console.log(error);
                        });
                } else {
                    this.editBatchModal = false;
                }
            }
        },
        async getSignatory() {
            if (this.entity && this.showBatches && type == 'employer') {
                let unionLocald = this.assignment.union_local_id ? this.assignment.union_local_id : null;
                let agreementId = this.assignment.agreement_id ? this.assignment.agreement_id : null;
                let url = `/signatory/${this.entity.id}/${unionLocald}/${agreementId}`;
                const response = await this.oasisApi.get(url);
                if (response.status == 200 && response.data) {
                    // normal case
                    return response.data;
                } else {
                    // this case will be really really rare case. we consider only one case that our server is down. but If our server down, other api calls will not be ran as well, so added just in case to avoid to be blocked.
                    return this.entity.name;
                }
            }
        },
        autoGenerateNewBatchName() {
            // If batch conditions are changed, this function will be ran to make default batch name.
            let autoName = this.newBatchWeekEnding.replaceAll('/','-');
            if (this.assignment.union_local_id) autoName += ' Union';
            else autoName += ' Non Union';

            if (this.newBatch.department_id) autoName += ` ${this.assignment.department}`;
            if (this.newBatch.signatory_name) autoName += ` ${this.newBatch.signatory_name}`;
            let addNum = autoName;
            // to generate auto-name. If there is same name, will be added _1, _2, _3 ...
            for(let count=1;count <= this.batches.length+1;count++) {
                let findIdx = this.batches.findIndex(bat => bat.name == addNum);
                if (findIdx == -1) {
                    autoName = addNum;
                    break;
                }
                addNum = autoName + '_' + count;
            }
            this.newBatch.name = autoName;
        },
        isChangedPrComments: _.debounce(function () {
            if (this.cardLocked && this.status < 3) {
                if (this.previousPrComment != this.payroll_comments) this.isPrCommentsDisabled = false;
                else this.isPrCommentsDisabled = true;
            }
          }, 500),
        // should get "YYYY-MM-DD" format
        compareTwoDates(date1, date2) {
            let date1Arr = date1.split('-');
            let date2Arr = date2.split('-');
            if (!date1Arr[0] || !date1Arr[1] || !date1Arr[2] || !date2Arr[0] || !date2Arr[1] || !date2Arr[2]) return false;

            let date1Num = Number(date1Arr[0] * 10000 + date1Arr[1] * 100 + date1Arr[2]);
            let date2Num = Number(date2Arr[0] * 10000 + date2Arr[1] * 100 + date2Arr[2]);

            return date1Num <= date2Num;
        },
        withinProdPhasesDate(date, field) {
            let isWithinPrepWrapDate = false;
            if (this.entity.prep_start_date && this.entity.prep_end_date && date) {
                let currentDate = new Date(date).toISOString().split('T')[0];
                if ( (this.compareTwoDates(this.entity.prep_start_date,currentDate)) && (this.compareTwoDates(currentDate,this.entity.prep_end_date)) ) isWithinPrepWrapDate = true;
            }
            if (!isWithinPrepWrapDate) {
                if (this.entity.post_start_date && this.entity.post_end_date && date) {
                    let currentDate = new Date(date).toISOString().split('T')[0];
                    if ( (this.compareTwoDates(this.entity.post_start_date,currentDate)) && (this.compareTwoDates(currentDate,this.entity.post_end_date)) ) isWithinPrepWrapDate = true;
                }
            }

            if (isWithinPrepWrapDate) {
                if (this.assignment.pw_budget_code || this.assignment.pw_fringe_code || this.assignment.pw_free_field || this.assignment.pw_free_field2 || this.assignment.pw_series_code || this.assignment.pw_location_code || this.assignment.pw_set_code) {
                    return this.assignment['pw_'+field];
                }
            }
            return this.assignment[field];
        },
        getHoursByBucket(bucket=null) {
            if (! bucket) return undefined;

            let hours = 0;
            if (this.brokenHours.week.hasOwnProperty(bucket) && !isNaN(this.brokenHours.week[bucket].hours)){
                hours += parseFloat(this.brokenHours.week[bucket].hours);
            }
            if (this.timecardType === 'biweekly' && this.brokenHours2 && this.brokenHours2.week.hasOwnProperty(bucket) && !isNaN(this.brokenHours2.week[bucket].hours)){
                hours += parseFloat(this.brokenHours2.week[bucket].hours);
            }

            return this.round(hours);
        },

        getHoursByBucketMatch(pattern=null) {
            if (! pattern) return undefined;
            let hours = 0;
            let week1 = Object.keys(this.brokenHours.week).filter(val => val.match(pattern));
            if (week1.length) {
                for (let i of week1) {
                    hours += this.brokenHours.week[i].hours || 0;
                }
            }

            if (this.timecardType === 'biweekly' && this.brokenHours2) {
                let week2 = Object.keys(this.brokenHours2.week).filter(val => val.match(pattern));
                if (week2.length) {
                    for (let i of week2) {
                        hours += this.brokenHours2.week[i].hours || 0;
                    }
                }
            }

            return this.round(hours);
        },

        getPayByBucket(bucket=null, skipWeek2=false) {
            if (! bucket) return undefined;

            let pay = 0;
            if (this.brokenHours.week.hasOwnProperty(bucket) && !isNaN(this.brokenHours.week[bucket].pay)){
                pay += parseFloat(this.brokenHours.week[bucket].pay) || 0;
            }
            if (!skipWeek2 && this.timecardType === 'biweekly' && this.brokenHours2 && this.brokenHours2.week.hasOwnProperty(bucket) && !isNaN(this.brokenHours2.week[bucket].pay)){
                pay += parseFloat(this.brokenHours2.week[bucket].pay) || 0;
            }

            return this.round(pay);
        },

        getPayByBucketMatch(pattern=null, skipWeek2=false) {
            if (! pattern) return undefined;
            let pay = 0;
            let week1 = Object.keys(this.brokenHours.week).filter(val => val.match(pattern));
            if (week1.length) {
                for (let i of week1) {
                    pay += this.brokenHours.week[i].pay || 0;
                }
            }

            if (!skipWeek2 && this.timecardType === 'biweekly' && this.brokenHours2) {
                let week2 = Object.keys(this.brokenHours2.week).filter(val => val.match(pattern));
                if (week2.length) {
                    for (let i of week2) {
                        pay += this.brokenHours2.week[i].pay || 0;
                    }
                }
            }

            return this.round(pay);
        },

        getValueByBucket(bucket=null, skipWeek2=false) {
            if (! bucket) return undefined;

            let value = 0;
            if (this.brokenHours.week.hasOwnProperty(bucket) && !isNaN(this.brokenHours.week[bucket].value)){
                value += parseFloat(this.brokenHours.week[bucket].value) || 0;
            }
            if (!skipWeek2 && this.timecardType === 'biweekly' && this.brokenHours2 && this.brokenHours2.week.hasOwnProperty(bucket) && !isNaN(this.brokenHours2.week[bucket].value)){
                value += parseFloat(this.brokenHours2.week[bucket].value) || 0;
            }

            return this.round(value);
        },

        getValueByBucketMatch(pattern=null, skipWeek2=false) {
            if (! pattern) return undefined;
            let value = 0;
            let week1 = Object.keys(this.brokenHours.week).filter(val => val.match(pattern));
            if (week1.length) {
                for (let i of week1) {
                    value += this.brokenHours.week[i].value || 0;
                }
            }

            if (!skipWeek2 && this.timecardType === 'biweekly' && this.brokenHours2) {
                let week2 = Object.keys(this.brokenHours2.week).filter(val => val.match(pattern));
                if (week2.length) {
                    for (let i of week2) {
                        value += this.brokenHours2.week[i].value || 0;
                    }
                }
            }

            return this.round(value);
        },
        async updatePrComments() {
            let response;
            let data = {
                payroll_comments: this.payroll_comments,
            };
            // console.log("id : " + this.timecard_id)
            if (this.adminAccess) response = await this.oasisV3Api.patch(`/admin/timecards/${this.timecard_id}`, data);
            else response = await this.oasisV3Api.patch(`/employer/timecards/${this.timecard_id}`, data)

            if (response && response.status == 200 || response.status == 201) {
                this.previousPrComment = this.payroll_comments;
                this.isPrCommentsDisabled = true;
             }
        },

        // Receives the current split from the Allocation component and parks it inside `overrides`
        // so it persists with the timecard (calc() already posts `overrides`). Empty/invalid-but-zero
        // splits are cleared so ProPay falls back to the default per-day project coding.
        onAllocationChanged(rows, isValid) {
            if (!this.overrides || typeof this.overrides !== 'object') this.overrides = {};
            this.allocationValid = isValid;
            if (Array.isArray(rows) && rows.length) {
                this.overrides.allocation = rows;
            } else {
                delete this.overrides.allocation;
            }
        },

        async calc(options) {
            const showDialog = (options && options.hideDialog === true) ? false : true;

            let data = {
                weekEnding: this.normalizeDate(this.weekEndingTime || this.weekEnding),
                timezone_entered: this.timezone_entered,
                timecard_id: this.timecard_id,

                startData: this.assignment,
                timecardData: this.week,
                timecardData2: this.week2,
                accrualData: this.accruals,
                employee_comments: this.employee_comments,
                employer_comments: this.employer_comments,
                payroll_comments: this.payroll_comments,
                overrides: this.overrides,
                timecardType: this.timecardType || 'weekly',
                batch_id: this.batch_id || null,
                token: $("#token").val()
            };

            if (this.timecard_id) {
                var type = 'patch';

                // Overrides
                if (this.overrides && (this.overrides.gross || this.overrides.mealPenalties)) {
                    data.brokenHours = this.brokenHours;
                    if (this.timecardType === 'biweekly') data.brokenHours2 = this.brokenHours2;
                }
            } else {
                var type = 'post';

                // This should only be on the initial POST
                this.timezone_entered = data.timezone_entered = this.timezone_local;
            }

            this.perLocked = true;
            this.empLocked = true;
            const response = await this.oasisApi[type](this.endpoints.timecard, data);
                if (response.status == 200){
                    this.modified = false;
                    this.isNew = false;
                    this.brokenHours = response.data.broken;
                    this.brokenHours2 = response.data.broken2 || this.brokenHours2;
                    this.previousPrComment = this.payroll_comments;
                    this.isPrCommentsDisabled = true;
                    this.isRefreshStart = false;
                    this.statusFull = response.data.status_full || this.statusFull;
                    this.checkAllowanceMessage();
                    // console.log(this.brokenHours);
                    if (showDialog) this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                } else if (response.status == 201) {
                    this.modified = false;
                    if (typeof response.data === 'object') {
                        this.timecard_id = response.data.id;
                        this.hash = response.data.hash;
                        this.brokenHours = response.data.broken;
                        this.brokenHours2 = response.data.broken2 || this.brokenHours2;
                        this.batch_id = response.data.batch_id || this.batch_id;
                        this.previousPrComment = this.payroll_comments;
                        this.isPrCommentsDisabled = true;
                        this.statusFull = response.data.status_full || this.statusFull;
                        this.isRefreshStart = false;
                        this.checkAllowanceMessage();
                        if (showDialog) this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK"  });
                    } else {
                        if (showDialog) this.createDialog({ "title": "Success", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                    this.getRelatedTimecards();
                } else if (response.status == 400 || response.status == 403) {
                    if (Array.isArray(response.data)) {
                        let message = '';
                        for (let i = 0; i < response.data.length; i++) {
                            let error = JSON.parse(response.data[i]);
                            $("input[name='" + error.field + "']").addClass('form-error2');
                            message += error.message + "\n";
                        }
                        this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                    } else if (response.data.message) {
                        this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                    } else {
                        this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                } else {
                    this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                }
            $("body").removeClass('waiting');
            this.calculatedLaborSubtotal = false;
            this.calculatedBreakouts = false;
            return true;
        },

        // Refresh only certain data related to start, not allowances
        async refreshAssignmentData(assignment) {
            if (! assignment) return false;
            this.isRefreshStart = true;
            if (this.showBatches) ((this.$refs['batch_id'] || {}).classList || {}).remove('form-error');
            this.important_message = '';
            this.assignment.id = assignment.id;
            this.assignment.hash = assignment.hash;
            this.assignment.kit_rental = assignment.kit_rental || '';
            this.assignment.kit_rental_tax = assignment.kit_rental_tax || '';
            this.assignment.phone_allow = assignment.phone_allow || '';
            this.assignment.per_diem = assignment.per_diem || '';
            this.assignment.per_diem_taxable = assignment.per_diem_taxable || '';
            this.assignment.lodging = assignment.lodging || '';
            this.assignment.lodging_tax = assignment.lodging_tax || '';
            this.assignment.car_rental = assignment.car_rental || '';
            this.assignment.department = assignment.department;
            this.assignment.department_id = assignment.department_id;
            this.assignment.entity_id = assignment.entity_id;
            this.assignment.employee = assignment.employee;
            this.assignment.employee_id = assignment.employee_id;
            this.assignment.loanout_status = assignment.loanout_status;
            this.assignment.rate = assignment.rate;
            this.assignment.rate_unit = assignment.rate_unit;
            this.assignment.rate_unit_id = assignment.rate_unit_id;
            this.assignment.hourly_rate = assignment.hourly_rate;
            this.assignment.rate_comment = assignment.rate_comment;
            this.assignment.guaranteed_hours = assignment.guaranteed_hours;
            this.assignment.guaranteed_hours_unit = assignment.guaranteed_hours_unit;
            this.assignment.guaranteed_hours_unit_id = assignment.guaranteed_hours_unit_id;
            this.assignment.guaranteed_hours_6th = assignment.guaranteed_hours_6th;
            this.assignment.guaranteed_hours_7th = assignment.guaranteed_hours_7th;
            this.assignment.kit_rate_unit_id = assignment.kit_rate_unit_id;
            this.assignment.phone_rate_unit_id = assignment.phone_rate_unit_id;
            this.assignment.pd_rate_unit_id = assignment.pd_rate_unit_id;
            this.assignment.lodging_rate_unit_id = assignment.lodging_rate_unit_id;
            this.assignment.car_rate_unit_id = assignment.car_rate_unit_id;
            this.assignment.kit_rate_unit = assignment.kit_rate_unit;
            this.assignment.phone_rate_unit = assignment.phone_rate_unit;
            this.assignment.pd_rate_unit = assignment.pd_rate_unit;
            this.assignment.lodging_rate_unit = assignment.lodging_rate_unit;
            this.assignment.car_rate_unit = assignment.car_rate_unit;
            this.assignment.job_title = assignment.job_title;
            this.assignment.job_title_id = assignment.job_title_id;
            this.assignment.job_title_override = assignment.job_title_override;
            this.assignment.flsa_type_id = assignment.flsa_type_id;
            this.assignment.legislative_type = assignment.legislative_type;
            this.assignment.legislative_type_id = assignment.legislative_type_id;
            this.assignment.currency = assignment.currency;
            this.assignment.currency_id = assignment.currency_id;
            this.assignment.rule_collection = assignment.rule_collection;
            this.assignment.rule_collection_id = assignment.rule_collection_id;
            this.assignment.scale_rate = assignment.scale_rate;
            this.assignment.scale_stn = assignment.scale_stn;
            this.assignment.union_local = assignment.union_local;
            this.assignment.union_local_id = assignment.union_local_id;
            this.assignment.union_jurisdiction = assignment.union_jurisdiction;
            this.assignment.union_jurisdiction_id = assignment.union_jurisdiction_id;
            this.assignment.union_schedule = assignment.union_schedule;
            this.assignment.union_schedule_id = assignment.union_schedule_id;
            this.assignment.union_hired_from = assignment.union_hired_from;
            this.assignment.union_hired_from_id = assignment.union_hired_from_id;
            this.assignment.start_date = assignment.start_date;
            this.assignment.term_date = assignment.term_date;
            this.assignment.union_ruleset_id = assignment.union_ruleset_id;
            this.assignment.union_location = assignment.union_location;
            this.assignment.union_location_id = assignment.union_location_id;
            this.assignment.union_on_prod = assignment.union_on_prod;
            this.assignment.union_on_prod_id = assignment.union_on_prod_id;
            this.assignment.union_flsa_type_id = assignment.union_flsa_type_id;
            this.assignment.union_rule_overrides = assignment.union_rule_overrides;
            this.assignment.metadata = assignment.metadata;
            this.assignment.budget_code = assignment.budget_code;
            this.assignment.fringe_code = assignment.fringe_code;
            this.assignment.series_code = assignment.series_code;
            this.assignment.location_code = assignment.location_code;
            this.assignment.set_code = assignment.set_code;
            this.assignment.free_field = assignment.free_field;
            this.assignment.free_field2 = assignment.free_field2;
            this.assignment.kr_loc_type = assignment.kr_loc_type;
            this.assignment.krtax_loc_type = assignment.krtax_loc_type;
            this.assignment.phone_loc_type = assignment.phone_loc_type;
            this.assignment.pd_loc_type = assignment.pd_loc_type;
            this.assignment.pd_taxable_loc_type = assignment.pd_taxable_loc_type;
            this.assignment.lodging_loc_type = assignment.lodging_loc_type;
            this.assignment.lodging_tax_loc_type = assignment.lodging_tax_loc_type;
            this.assignment.cr_loc_type = assignment.cr_loc_type;
            this.assignment.pw_budget_code = assignment.pw_budget_code;
            this.assignment.pw_fringe_code = assignment.pw_fringe_code;
            this.assignment.pw_series_code = assignment.pw_series_code;
            this.assignment.pw_location_code = assignment.pw_location_code;
            this.assignment.pw_set_code = assignment.pw_set_code;
            this.assignment.pw_free_field = assignment.pw_free_field;
            this.assignment.pw_free_field2 = assignment.pw_free_field2;
            this.assignment.work_day = assignment.work_day || 0;
            this.assignment.agent_fee = assignment.agent_fee || 0;

            if (this.assignment.union_local_id && this.enableWorkDay) this.week.overrideDay7 = this.assignment.work_day ? this.assignment.work_day == 0 ? null : this.assignment.work_day : null;
            // refresh batches.
            await this.getBatches();

            // need to check if prep/wrap date were changed by htg-admin.
            let response = await this.oasisApi.get('/entities');
            if ( (response.status == 200 || response.status == 201) && typeof response.data === 'object') {
                this.entity.prep_start_date = response.data.prep_start_date;
                this.entity.prep_end_date = response.data.prep_end_date;
                this.entity.post_start_date = response.data.post_start_date;
                this.entity.post_end_date = response.data.post_end_date;
            }
            for (let dateData in this.week) {
                if (this.week[dateData] && this.week[dateData].account) {
                    this.week[dateData].account.account = this.withinProdPhasesDate(this.week[dateData].date.full, 'budget_code');
                    this.week[dateData].account.fringe = this.withinProdPhasesDate(this.week[dateData].date.full, 'fringe_code');
                    this.week[dateData].account.series = this.withinProdPhasesDate(this.week[dateData].date.full, 'series_code');
                    this.week[dateData].account.location = this.withinProdPhasesDate(this.week[dateData].date.full, 'location_code');
                    this.week[dateData].account.set = this.withinProdPhasesDate(this.week[dateData].date.full, 'set_code');
                    this.week[dateData].account.freeField = this.withinProdPhasesDate(this.week[dateData].date.full, 'free_field');
                    this.week[dateData].account.freeField2 = this.withinProdPhasesDate(this.week[dateData].date.full, 'free_field2');
                }
            }
            for (let dateData in this.week2) {
                if (this.week[dateData] && this.week2[dateData].account) {
                    this.week2[dateData].account.account = this.withinProdPhasesDate(this.week2[dateData].date.full, 'budget_code');
                    this.week2[dateData].account.fringe = this.withinProdPhasesDate(this.week2[dateData].date.full, 'fringe_code');
                    this.week2[dateData].account.series = this.withinProdPhasesDate(this.week2[dateData].date.full, 'series_code');
                    this.week2[dateData].account.location = this.withinProdPhasesDate(this.week2[dateData].date.full, 'location_code');
                    this.week2[dateData].account.set = this.withinProdPhasesDate(this.week2[dateData].date.full, 'set_code');
                    this.week2[dateData].account.freeField = this.withinProdPhasesDate(this.week2[dateData].date.full, 'free_field');
                    this.week2[dateData].account.freeField2 = this.withinProdPhasesDate(this.week2[dateData].date.full, 'free_field2');
                }
            }
        },

        checkHiredTermDate() {
            // without weekending, there is no standard to compare with.
            if (!this.weekEnding) return;
            this.system_message = '';
            let startDate = this.assignment.start_date ? new Date(this.assignment.start_date) : '';
            let termDate = this.assignment.term_date ? new Date(this.assignment.term_date) : '';
            let startWeekEnding = this.timecardType === 'weekly' ? this.parseLuxon(this.weekEnding).minus({days: 6}).toJSDate() : this.parseLuxon(this.weekEnding).minus({days: 13}).toJSDate();
            let endWeekEnding = this.parseLuxon(this.weekEnding).toJSDate();

            if (startDate && startDate > startWeekEnding) {
                this.system_message += 'Your hire date is ' + DateTime.fromJSDate(startDate).toFormat(this.format)  + '.  You cannot add work times before this date.<br>';
            }
            if (termDate && termDate < endWeekEnding) {
                this.system_message += 'Your termination date is ' + DateTime.fromJSDate(termDate).toFormat(this.format)  + '.  You cannot add more work times until your employer extends this date.<br>';
            }
        },

        // used to set timecard header after loading employee
        async updateAssignment(assignment) {
            if (! assignment) return false;

            if (this.type == 'employer') {
                if (assignment.employee_id) this.getEmployee(assignment.employee_id); // to get special type in employee object for agent_fee
            }
            // Must assign manually to avoid processing errors and properties missing in Timedata class.
            this.assignment.id = assignment.id || ''; 
            this.assignment.hash = assignment.hash || ''; 
            this.assignment.department = assignment.department || ''; 
            this.assignment.department_id = assignment.department_id || ''; 
            this.assignment.entity = assignment.entity || ''; 
            this.assignment.entity_id = assignment.entity_id || ''; 
            this.assignment.employee = assignment.employee || ''; 
            this.assignment.employee_id = assignment.employee_id || ''; 
            this.assignment.loanout_status = assignment.loanout_status || '';
            this.assignment.rate = assignment.rate || '';
            this.assignment.rate_unit = assignment.rate_unit || '';
            this.assignment.rate_unit_id = assignment.rate_unit_id || '';
            this.assignment.guaranteed_hours = assignment.guaranteed_hours || '';
            this.assignment.guaranteed_hours_unit = assignment.guaranteed_hours_unit || '';
            this.assignment.guaranteed_hours_unit_id = assignment.guaranteed_hours_unit_id || '';
            this.assignment.guaranteed_hours_6th = assignment.guaranteed_hours_6th || '';
            this.assignment.guaranteed_hours_7th = assignment.guaranteed_hours_7th || '';
            this.assignment.hourly_rate = assignment.hourly_rate || '';
            this.assignment.rate_comment = assignment.rate_comment || '';
            this.assignment.job_title = assignment.job_title || '';
            this.assignment.job_title_id = assignment.job_title_id || '';
            this.assignment.job_title_override = assignment.job_title_override || '';
            this.assignment.occ_code = assignment.occ_code || '';
            this.assignment.location = assignment.location || '';
            this.assignment.location_id = assignment.location_id || '';
            this.assignment.budget_code = assignment.budget_code || '';
            this.assignment.fringe_code = assignment.fringe_code || '';
            this.assignment.series_code = assignment.series_code || '';
            this.assignment.location_code = assignment.location_code || '';
            this.assignment.set_code = assignment.set_code || '';
            this.assignment.free_field = assignment.free_field || '';
            this.assignment.free_field2 = assignment.free_field2 || '';
            this.assignment.pw_budget_code = assignment.pw_budget_code || '';
            this.assignment.pw_fringe_code = assignment.pw_fringe_code || '';
            this.assignment.pw_series_code = assignment.pw_series_code || '';
            this.assignment.pw_location_code = assignment.pw_location_code || '';
            this.assignment.pw_set_code = assignment.pw_set_code || '';
            this.assignment.pw_free_field = assignment.pw_free_field || '';
            this.assignment.pw_free_field2 = assignment.pw_free_field2 || '';
            this.assignment.flat_payment = assignment.flat_payment || '';
            this.assignment.kit_rental = assignment.kit_rental || '';
            this.assignment.kit_rental_tax = assignment.kit_rental_tax || '';
            this.assignment.kit_inventory_id = assignment.kit_inventory_id || '';
            this.assignment.per_diem = assignment.per_diem || '';
            this.assignment.per_diem_taxable = assignment.per_diem_taxable || '';
            this.assignment.lodging = assignment.lodging || '';
            this.assignment.lodging_tax = assignment.lodging_tax || '';
            this.assignment.phone_allow = assignment.phone_allow || '';
            this.assignment.per_diem_advance = assignment.per_diem_advance || '';
            this.assignment.car_rental = assignment.car_rental || '';
            this.assignment.other = assignment.other || '';
            this.assignment.agent_fee = assignment.agent_fee || '';
            this.assignment.mileage = assignment.mileage || '';
            this.assignment.kr_code = assignment.kr_code || '';
            this.assignment.krtax_code = assignment.krtax_code || '';
            this.assignment.kit_rate_unit_id = assignment.kit_rate_unit_id || '';
            this.assignment.kr_cap = assignment.kr_cap || '';
            this.assignment.krtax_cap = assignment.krtax_cap || '';
            this.assignment.pd_code = assignment.pd_code || '';
            this.assignment.pd_taxable_code = assignment.pd_taxable_code || '';
            this.assignment.pd_rate_unit_id = assignment.pd_rate_unit_id || '';
            this.assignment.lodging_code = assignment.lodging_code || '';
            this.assignment.lodging_tax_code = assignment.lodging_tax_code || '';
            this.assignment.lodging_rate_unit_id = assignment.lodging_rate_unit_id || '';
            this.assignment.phone_allow_code = assignment.phone_allow_code || '';
            this.assignment.phone_cap = assignment.phone_cap || '';
            this.assignment.phone_rate_unit_id = assignment.phone_rate_unit_id || '';
            this.assignment.pd_advance_code = assignment.pd_advance_code || '';
            this.assignment.cr_code = assignment.cr_code || '';
            this.assignment.cr_cap = assignment.cr_cap || '';
            this.assignment.car_rate_unit_id = assignment.car_rate_unit_id || '';
            this.assignment.mi_code = assignment.mi_code || '';
            this.assignment.other_code = assignment.other_code || '';
            this.assignment.agent_code = assignment.agent_code || '';
            this.assignment.kr_free_field = assignment.kr_free_field || '';
            this.assignment.krtax_free_field = assignment.krtax_free_field || '';
            this.assignment.pd_free_field = assignment.pd_free_field || '';
            this.assignment.pdtax_free_field = assignment.pdtax_free_field || '';
            this.assignment.lodging_free_field = assignment.lodging_free_field || '';
            this.assignment.lodging_tax_free_field = assignment.lodging_tax_free_field || '';
            this.assignment.phone_allow_free_field = assignment.phone_allow_free_field || '';
            this.assignment.pdadv_free_field = assignment.pdadv_free_field || '';
            this.assignment.cr_free_field = assignment.cr_free_field || '';
            this.assignment.mi_free_field = assignment.mi_free_field || '';
            this.assignment.other_free_field = assignment.other_free_field || '';
            this.assignment.agent_free_field = assignment.agent_free_field || '';
            this.assignment.kr_free_field2 = assignment.kr_free_field2 || '';
            this.assignment.krtax_free_field2 = assignment.krtax_free_field2 || '';
            this.assignment.pd_free_field2 = assignment.pd_free_field2 || '';
            this.assignment.pdtax_free_field2 = assignment.pdtax_free_field2 || '';
            this.assignment.lodging_free_field2 = assignment.lodging_free_field2 || '';
            this.assignment.lodging_tax_free_field2 = assignment.lodging_tax_free_field2 || '';
            this.assignment.phone_allow_free_field2 = assignment.phone_allow_free_field2 || '';
            this.assignment.pdadv_free_field2 = assignment.pdadv_free_field2 || '';
            this.assignment.cr_free_field2 = assignment.cr_free_field2 || '';
            this.assignment.mi_free_field2 = assignment.mi_free_field2 || '';
            this.assignment.other_free_field2 = assignment.other_free_field2 || '';
            this.assignment.agent_free_field2 = assignment.agent_free_field2 || '';
            this.assignment.kr_loc_type = assignment.kr_loc_type || '';
            this.assignment.krtax_loc_type = assignment.krtax_loc_type || '';
            this.assignment.phone_loc_type = assignment.phone_loc_type || '';
            this.assignment.pd_loc_type = assignment.pd_loc_type || '';
            this.assignment.pd_taxable_loc_type = assignment.pd_taxable_loc_type || '';
            this.assignment.lodging_loc_type = assignment.lodging_loc_type || '';
            this.assignment.lodging_tax_loc_type = assignment.lodging_tax_loc_type || '';
            this.assignment.cr_loc_type = assignment.cr_loc_type || '';
            this.assignment.flsa_type_id = assignment.flsa_type_id || '';
            this.assignment.legislative_type = assignment.legislative_type || '';
            this.assignment.legislative_type_id = assignment.legislative_type_id || '';
            this.assignment.currency = assignment.currency || '';
            this.assignment.currency_id = assignment.currency_id || '';
            this.assignment.rule_collection = assignment.rule_collection || '';
            this.assignment.rule_collection_id = assignment.rule_collection_id || '';
            this.assignment.scale_rate = assignment.scale_rate || '';
            this.assignment.scale_stn = assignment.scale_stn || '';
            this.assignment.union_local = assignment.union_local || '';
            this.assignment.union_local_id = assignment.union_local_id || '';
            this.assignment.union_jurisdiction = assignment.union_jurisdiction || '';
            this.assignment.union_jurisdiction_id = assignment.union_jurisdiction_id || '';
            this.assignment.union_schedule = assignment.union_schedule || '';
            this.assignment.union_schedule_id = assignment.union_schedule_id || '';
            this.assignment.union_hired_from = assignment.union_hired_from || '';
            this.assignment.union_hired_from_id = assignment.union_hired_from_id || '';
            this.assignment.union_ruleset_id = assignment.union_ruleset_id || '';
            this.assignment.union_location = assignment.union_location || '';
            this.assignment.union_location_id = assignment.union_location_id || '';
            this.assignment.union_on_prod = assignment.union_on_prod || '';
            this.assignment.union_on_prod_id = assignment.union_on_prod_id || '';
            this.assignment.union_flsa_type_id = assignment.union_flsa_type_id || '';
            this.assignment.union_rule_overrides = assignment.union_rule_overrides || {};
            this.assignment.start_date = assignment.start_date || '';
            this.assignment.term_date = assignment.term_date || '';
            this.assignment.agreement = assignment.agreement || '';
            this.assignment.agreement_id = assignment.agreement_id || '';
            this.assignment.metadata = assignment.metadata || '';
            this.assignment.work_day = assignment.work_day || 0;
            if (this.assignment.union_local_id && this.enableWorkDay) this.week.overrideDay7 = this.assignment.work_day ? this.assignment.work_day == 0 ? null : this.assignment.work_day : null;

            // 158 - Week, 159 - Day
            this.assignment.kit_rate_unit = assignment.kit_rate_unit ? assignment.kit_rate_unit : assignment.kit_rate_unit_id == '159' ? 'Day' : '';
            this.assignment.pd_rate_unit = assignment.pd_rate_unit ? assignment.pd_rate_unit : assignment.pd_rate_unit_id == '159' ? 'Day' : '';
            this.assignment.lodging_rate_unit = assignment.lodging_rate_unit ? assignment.lodging_rate_unit : assignment.lodging_rate_unit_id == '159' ? 'Day' : '';
            this.assignment.phone_rate_unit = assignment.phone_rate_unit ? assignment.phone_rate_unit : assignment.phone_rate_unit_id == '159' ? 'Day' : '';
            this.assignment.car_rate_unit = assignment.car_rate_unit ? assignment.car_rate_unit : assignment.car_rate_unit_id == '159' ? 'Day' : '';

            // set autocomplete preselect data
            this.selected_budget_code = assignment.budget_code || '';
            this.selected_fringe_code = assignment.fringe_code || '';
            this.selected_free_field = assignment.free_field || '';
            this.selected_free_field2 = assignment.free_field2 || '';
            this.selected_series_code = assignment.series_code || '';
            this.selected_location_code = assignment.location_code || '';
            this.selected_set_code = assignment.set_code || '';
            this.selected_pw_budget_code = assignment.pw_budget_code || '';
            this.selected_pw_fringe_code = assignment.pw_fringe_code || '';
            this.selected_pw_free_field = assignment.pw_free_field || '';
            this.selected_pw_free_field2 = assignment.pw_free_field2 || '';
            this.selected_pw_series_code = assignment.pw_series_code || '';
            this.selected_pw_location_code = assignment.pw_location_code || '';
            this.selected_pw_set_code = assignment.pw_set_code || '';
            this.selected_kr_code = assignment.kr_code || '';
            this.selected_kr_free_field = assignment.kr_free_field || '';
            this.selected_kr_free_field2 = assignment.kr_free_field2 || '';
            this.selected_krtax_code = assignment.krtax_code || '';
            this.selected_krtax_free_field = assignment.krtax_free_field || '';
            this.selected_krtax_free_field2 = assignment.krtax_free_field2 || '';
            this.selected_pd_code = assignment.pd_code || '';
            this.selected_pd_free_field = assignment.pd_free_field || '';
            this.selected_pd_free_field2 = assignment.pd_free_field2 || '';
            this.selected_pd_taxable_code = assignment.pd_taxable_code || '';
            this.selected_pdtax_free_field = assignment.pdtax_free_field || '';
            this.selected_pdtax_free_field2 = assignment.pdtax_free_field2 || '';
            this.selected_lodging_code = assignment.lodging_code || '';
            this.selected_lodging_free_field = assignment.lodging_free_field || '';
            this.selected_lodging_free_field2 = assignment.lodging_free_field2 || '';
            this.selected_lodging_tax_code = assignment.lodging_tax_code || '';
            this.selected_lodging_tax_free_field = assignment.lodging_tax_free_field || '';
            this.selected_lodging_tax_free_field2 = assignment.lodging_tax_free_field2 || '';
            this.selected_pd_advance_code = assignment.pd_advance_code || '';
            this.selected_pdadv_free_field = assignment.pdadv_free_field || '';
            this.selected_pdadv_free_field2 = assignment.pdadv_free_field2 || '';
            this.selected_mi_code = assignment.mi_code || '';
            this.selected_mi_free_field = assignment.mi_free_field || '';
            this.selected_mi_free_field2 = assignment.mi_free_field2 || '';
            this.selected_phone_allow_code = assignment.phone_allow_code || '';
            this.selected_phone_allow_free_field = assignment.phone_allow_free_field || '';
            this.selected_phone_allow_free_field2 = assignment.phone_allow_free_field2 || '';
            this.selected_cr_code = assignment.cr_code || '';
            this.selected_cr_free_field = assignment.cr_free_field || '';
            this.selected_cr_free_field2 = assignment.cr_free_field2 || '';
            this.selected_agent_code = assignment.agent_code || '';
            this.selected_agent_free_field = assignment.agent_free_field || '';
            this.selected_agent_free_field2 = assignment.agent_free_field2 || '';

            if (assignment.recurring_comments && this.employer_comments === '') {
                this.employer_comments = assignment.recurring_comments;
            }

            this.employee = { "name": assignment.employee, "id": assignment.employee_id };
            this.defaultLocation = { "name": assignment.location, "id": assignment.location_id };
            this.empLocked = true;

            if (type === 'employer' && this.weekEnding) this.perLocked = true;

            if (this.status_full === 'Terminated') {
                this.perLocked = true;
                this.empLocked = true;
            }

            // Set work days if exempt and not already set
            if (assignment.legislative_type === 'exempt') {
                this.exempt = true;
            } else {
                this.exempt = false;
            }                        

            // Timecard Layout
            if (assignment.agreement && assignment.agreement.toLowerCase().match(/sag/)) {
                this.timecardLayout = 'sag'
            }

            this.newOtherPay.budget_code = assignment.budget_code;
            this.newOtherPay.fringe_code = assignment.fringe_code;
            this.newOtherPay.series_code = assignment.series_code;
            this.newOtherPay.location_code = assignment.location_code;
            this.newOtherPay.set_code = assignment.set_code;
            this.newOtherPay.free_field = assignment.free_field;
            this.newOtherPay.free_field2 = assignment.free_field2;
            if (typeof this.assignment.additional_allowances !== 'object') {
                this.assignment.additional_allowances = {};
            }
            if (this.isNew) await this.getPreviousTimecard();

            await this.getBatches();
            this.checkHiredTermDate();
            this.getAssignedProjects();
        },

        updateLocation (event) {
            // When using autocomplete component, event will be the location object. When using select dropdown, event will be the change event.
            if ((event || {}).id) {
                this.assignment.location_id = event.id;
                this.assignment.location = event.name;
                this.locationChanged = true;
                this.modified = true;
            } else if (event && event.target && event.target.value) {
                const locationId = parseInt(event.target.value);
                const location = this.projectLocations.find((loc) => parseInt(loc.id) === locationId) || {};
                this.assignment.location_id = locationId;
                this.assignment.location = location.name;
                this.locationChanged = true;
                this.modified = true;
            } else {
                // console.log('location cleared', event);
            }
        },

        // Set to a time that will always be the date in just about every timezone
        normalizeDate(date) {
            let utcWeekEnding = this.parseLuxon(date).toJSDate();
            utcWeekEnding.setUTCHours(10);
            // set mins too. ex) india UTC + 5:30 - our standard is 10:00:00, so we need to remove mins.
            utcWeekEnding.setUTCMinutes(0); 
            return utcWeekEnding;
        },

        // set tc days after selecting a pay period
        updateDays(weekEnding) {
            const oldWeekEndingTime = this.weekEndingTime;
            this.weekEndingTime = weekEnding; // Needed for international shows past the dateline
            this.weekEnding = DateTime.fromJSDate(this.normalizeDate(weekEnding)).toFormat(this.format);
            this.timezone_local = this.parseLuxon(this.weekEnding).toJSDate().getTimezoneOffset();
            let utcWeekEnding = this.normalizeDate(weekEnding);
            this.getPreviousTimecard();
            this.getRelatedTimecards();
            let weeks;
            let backCounter;
            let termDate = this.assignment.term_date;
            if (termDate) termDate = this.normalizeDate(new Date(this.assignment.term_date));
            let startDate = this.assignment.start_date;
            if (startDate) startDate = this.normalizeDate(new Date(this.assignment.start_date));

            if (this.timecardType === 'biweekly') {
                weeks = [ this.week, this.week2 ];
                backCounter = 14;

                // If bi-weekly, need ot makes sure system generated date and user selected date are in the correct pay cycle
                let dateDiff = (new Date(utcWeekEnding).getTime() - new Date(this.nextWeekEnding).getTime()) / 1000;
                const diffWeeks = Math.abs(Math.round(dateDiff /= (60 * 60 * 24 * 7)));
                if (diffWeeks % 2) {
                    // console.log('Reverting to weekEnding: ' + weekEnding);
                    if (oldWeekEndingTime) {
                        this.weekEndingTime = oldWeekEndingTime;
                        this.weekEnding = this.$refs['weekEnding'].inputValue = DateTime.fromJSDate(this.normalizeDate(oldWeekEndingTime)).toFormat(this.format);
                    } else {
                        this.weekEndingTime = this.weekEnding = null;
                        this.$refs['weekEnding'].inputValue = '';
                    }
                    this.createDialog({ "title": "Invalid Week Ending Date", "body": "You are in a bi-weekly pay period. Please select another week earlier or later than this one.", "buttonYesLabel": "OK", "buttonNo": false });
                    return false;
                }
            } else {
                weeks = [ this.week ];
                backCounter = 7;
            }

            weeks.forEach((week, index) => {
                // Set dates in the Week object
                for (let i = 1; i <= 7; i++) {
                    let date = new Date(utcWeekEnding);
                    date.setDate(date.getDate() + (i - backCounter + (index * 7))); // add 7 days for each week object

                    let tempLocale = this.locale === 'en-CA' ? 'en-GB' : this.locale;
                    let shortDate = date.toLocaleDateString(tempLocale, {
                        weekday: 'short',
                        day: '2-digit',
                        month: '2-digit',
                    });
                    let dayVar = 'day_' + i;
                    week[dayVar].date = { short: shortDate, full: date };
                }
            })

            // Days were just re-dated (Copy Prev, Clone to another pay period, week-ending change).
            // Make sure each day's project is still within its assigned window.
            this.validateProjectDates(weeks);

            $("input[name='employee']").focus();
            this.checkHiredTermDate();
        },

        // For each re-dated day, verify the project is within its assigned window; if not, unset the
        // project + project_id for that day and show an error. Mirrors updateProject() in timecardDay.vue.
        validateProjectDates(weeks) {
            if (! this.showAssignedProjects) return;
            const projects = this.projects;
            if (! Array.isArray(projects) || ! projects.length) return;

            weeks.forEach((week) => {
                for (let i = 1; i <= 7; i++) {
                    const day = week['day_' + i];
                    if (! day || ! day.project || ! day.date || ! day.date.full) continue;
                    const project = projects.find((p) => p.code == day.project);
                    if (! project) continue;
                    const dayDate = new Date(day.date.full);
                    if (project.date_start && dayDate < new Date(project.date_start.replace(/-/g, '/'))) {
                        day.project = '';
                        day.project_id = '';
                        this.showError('A project on ' + day.date.short + ' has not been assigned for that date and was removed. Please reselect a project or use a date starting ' + project.date_start + ' or later.');
                    } else if (project.date_end && dayDate > new Date(project.date_end.replace(/-/g, '/'))) {
                        day.project = '';
                        day.project_id = '';
                        this.showError('A project on ' + day.date.short + ' has not been assigned for that date and was removed. Please reselect a project or use a date ending ' + project.date_end + ' or earlier.');
                    }
                }
            });
        },

        // When loading times from server, need to convert into javascript date format
        fixDates(weekObject) {
            for (let dayObject in weekObject) {
                for (let time in weekObject[dayObject]) {
                    if (time && time.match(/^time_/)) {
                        weekObject[dayObject][time] = new Date(weekObject[dayObject][time]);
                    }
                }
            }
            return weekObject;
        },

        // Double check timecard is saved prior to showing the modal.
        showReview() {
            if (this.modified) {
                this.createDialog({ "title": "Warning", "body": 'Please Save the Timecard Before Reviewing.', "buttonNo": false, "buttonYesLabel": "OK" });
            } else {
                this.showReviewBox = true;
            }
        },

        // Mark timecards as reviewed (if status is false, unmark reviewed status)
        async saveReview(data=null) {
            if (!data.hash) data.hash = this.hash;
            const response = await this.oasisApi.post('/review/timecard', data);
            let message;
            const success = response.status === 200 || response.status === 201;
            if (success && data.kickback) {
                this.employerMessage = data.comments;
                this.showReviewBox = false;
                this.changeApi('unfinalize', this.hash);
            } else if (success && data.approve) {
                await this.approve(data.bypass, false); // Don't show approve dialog
                this.reviews = [ response.data || data ]; // Update latest review
                this.gotoNextTc();
            } else if (success && data.kickbackApprovalId) {
                this.employerMessage = data.comments;
                this.showReviewBox = false;
                await this.kickbackApproval(data.kickbackApprovalId, data.status || false);
            } else if (success) {
                this.gotoNextTc();
                this.reviews = [ response.data || data ]; // Update latest review
                // message = 'Review Saved. Click OK to go to the next timecard.';
                // this.createDialog({ "title": "Success", "body": message, "buttonNo": false, "buttonYesLabel": "OK", "buttonYesAction": function () { app.gotoNextTc(); } });
            } else {
                message = 'Review not saved. Please contact Support.<br />' + response.data.message;
                this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"});
            }
        },

        approve(bypass=false, showDialog=true, showNextTimecard=false) {
            let data = {
                timecards: [this.hash],
                finalApproval: bypass
            };

            let patchResult = false;
            this.oasisApi.patch('/approve/timecard', data)
                .then(response => {
                    if (response.status !== 200) {
                        this.createDialog({ "title": "Error", "body": (response && response.data && response.data.message ? response.data.message : 'Failed to Approve.'), "buttonNo": false, "buttonYesLabel": "OK" });
                        return;
                    } else {
                        patchResult = true;
                    }

                    if (showDialog) {
                        this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        this.loadByHash(this.hash, false, false);
                    }
                })
                .finally(() => {
                    if (patchResult && showNextTimecard && this.nextTimecard) {
                        this.gotoNextTc();
                    } else if (patchResult) {
                        const message = 'Timecard approved.  No further timecards to approve.';
                        this.statusFull = 'Approved';
                        this.user_can_approve = false,
                        this.createDialog({ "title": "Success", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                })
            ;
        },

        async employeeApprove() {
            if (this.modified === true) {
                this.createDialog({ "title": "Warning", "body": 'Please Save the Timecard Before Finalizing.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            // only double check If total pay is 0 to check whether this timecard was calculated or was saved without calc
            if (this.total_pay == 0) {
                if (! await this.preCalcCheck(true)) return;
            }

            var data = [ this.timecard_id ];
            this.oasisApi.patch(this.endpoints.timecardEmployeeApprove, data)
                .then(response => {
                    if (response.status == 200){
                        const message = response.data + ((type === 'employer') ? '<br /><br />You may still have to approve this timecard from the <a href="/oasis/welcome/dashboard">dashboard</a>.': '');
                        this.employee_status = 1;
                        this.statusFull = 'Employee Completed';
                        this.createDialog({ "title": "Success", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        this.loadByHash(this.hash, false, false);

                        if (this.showBatches && ! this.batch_id) {
                            this.batch_id = this.showBatches;
                        }
                        if (this.batch_id) this.calc({ hideDialog: true });
                    } else if (response.status == 400 || response.status == 403) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                })
                .catch(error => { console.log('error: '); console.log(error); alert (error); });
        },

        // Reload assignment data fresh.  Admins only
        refreshAssignment() {
            if (type === 'employee') return false;
            if (!this.assignment.hash) {
                this.createDialog({ "title": "Warning", "body": 'Please select an employee.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            this.oasisApi.get(this.endpoints.assignment + '/' + this.assignment.hash)
                .then(response => {
                    // console.log (response);
                    if (response.status === 200 && typeof response.data === 'object') {
                        this.refreshAssignmentData(response.data);
                        this.checkMinWage();
                        this.checkHiredTermDate();
                        this.modified = true;
                    }
                })
                .catch(error => { console.log(error); }
            )
            this.checkStartStatus();
        },

        // When an employee is selected and the pay period is changed, we need to 
        // check if a timecard exists for the pay period
        lookupTimecard(assignment) {
            if (! assignment) return false;
            if (type === 'employer') {
                this.updateAssignment(assignment);
            }
            // Is this from autocomplete?  If so, the value should be the assignment id found when looking up the employee
            if (assignment.employee_id) {
                this.oasisApi.get(this.endpoints.timecardEmployee + assignment.id + '/' + this.normalizeDate(this.weekEndingTime || this.weekEnding).toISOString())
                    .then(response => {
                        // console.log (response);
                        if (response.status === 200 && response.data === false) {
                            // No data to retrieve
                            // this.cardLocked = false;
                            return true;
                        } else if (response.status === 200 && typeof response.data === 'object') {
                            this.updateTimecard(response.data);
                        }
                    })
                    .catch(error => { console.log(error); });
            }
            this.checkMinWage();
            this.checkStartStatus();
        },

        checkWeekEnding(weekEnding) {
            // console.log ('checking weekEnding: ' + weekEnding);
            // console.log ('old weekEnding: ' + this.weekEnding, weekEnding);
            weekEnding = weekEnding.replaceAll('-','/');
            let date = new Date(weekEnding);
            let stopUpdate = false; // Need a way to stop updating the dates if there is a problem

            // Set hours from Calendar to 10 to handle all timezones
            if (date.getHours() === 0) {
                date.setHours(10);
                weekEnding = date;
            }

            // Don't update if a bad week ending.
            if (! weekEnding && ! this.weekEnding) {
                return false;
            } else if (this.disabled.includes(date.getDay())) {
                this.createDialog({ "title": "Error", "body": 'This date is not allowed.', "buttonNo": false, "buttonYesLabel": "OK" });
                weekEnding = this.weekEnding;
                return false;
            } else if (! weekEnding) {
                weekEnding = this.weekEnding;
                return false;
            }

            // The rest of this function assumes there is an active timecard and a week ending change.
            this.oasisApi.get(this.endpoints.timecardEmployee + this.assignment.id + '/' + this.normalizeDate(weekEnding).toISOString())
                .then(response => {
                    // console.log (response);
                    if (response.status === 200 && response.data === false) {
                        // No data to retrieve
                    } else if (response.status === 200 && response.data === 'No matching timecard') {
                        // This means that it's ok to set this timecard to the new weeke ending
                        this.weekEnding = weekEnding;
                    } else if (response.status === 200 && typeof response.data === 'object') {
                        // This means that there is an existing timecard and to prompt the user to load
                        // If they click no, we do not want this to update
                        stopUpdate = true;
                        this.createDialog({ "title": "Load Existing Timecard?", "body": "There is a timecard for that pay period.  Load?",
                            "buttonYesAction": function () { app.updateTimecard(response.data); }
                        });
                    }
                })
                .catch(error => {
                    console.log(error);
                    return false;
                })
                .finally(() => {
                    if (stopUpdate) {
                        // Set field back to original weekending
                        this.newWeekEnding = this.weekEnding;
                        return false;
                    } else {
                        this.updateDays(weekEnding);
                        this.getBatches();
                    }
                    return true;
                });
        },

        // Function to clear out in/out times
        resetDays() {
            this.$refs['day_1'].clearDay();
            this.$refs['day_2'].clearDay();
            this.$refs['day_3'].clearDay();
            this.$refs['day_4'].clearDay();
            this.$refs['day_5'].clearDay();
            this.$refs['day_6'].clearDay();
            this.$refs['day_7'].clearDay();
            if (this.$refs['week2_day_1']) this.$refs['week2_day_1'].clearDay();
            if (this.$refs['week2_day_2']) this.$refs['week2_day_2'].clearDay();
            if (this.$refs['week2_day_3']) this.$refs['week2_day_3'].clearDay();
            if (this.$refs['week2_day_4']) this.$refs['week2_day_4'].clearDay();
            if (this.$refs['week2_day_5']) this.$refs['week2_day_5'].clearDay();
            if (this.$refs['week2_day_6']) this.$refs['week2_day_6'].clearDay();
            if (this.$refs['week2_day_7']) this.$refs['week2_day_7'].clearDay();
        },

        updateTimecard(timecard) {
            if (! timecard) return false;

            this.resetDays();
            this.timecard_id = timecard.id;
            this.newWeekEnding = this.weekEnding = timecard.week_ending;
            this.brokenHours = timecard.broken_object;
            this.brokenHours2 = timecard.broken_object2 || this.brokenHours2;
            this.overrides = typeof timecard.overrides === 'object' ? timecard.overrides : (typeof timecard.overrides === 'string' && this.isJson(timecard.overrides) ? JSON.parse(timecard.overrides) : this.overrides);
            // Restore a previously-saved pay allocation (stored inside overrides).
            this.allocation = (this.overrides && Array.isArray(this.overrides.allocation)) ? this.overrides.allocation : [];
            this.assignment = timecard.assignment_object;
            if (timecard.accrual_object && typeof(timecard.accrual_object) === 'object') this.accruals = timecard.accrual_object;
            this.week = timecard.timecard_object;
            this.week2 = timecard.timecard_object2 || this.week2;
            this.employee_comments = timecard.employee_comments;
            this.employer_comments = timecard.employer_comments;
            this.payroll_comments = this.previousPrComment = timecard.payroll_comments;
            this.timezone_entered = parseInt(timecard.timezone_entered);
            this.batch_id = timecard.batch_id || '';
            this.batch = timecard.batch || '';
            this.employee_status = timecard.employee_status;
            this.employer_status = timecard.employer_status;
            this.status = timecard.status;
            this.payroll_status = timecard.payroll_status;
            this.statusFull = timecard.status_full;
            this.hash = timecard.hash;
            this.time_added = timecard.time_added;
            this.time_updated = timecard.time_updated;

            // set autocomplete preselect data
            this.selected_budget_code = timecard.assignment_object && timecard.assignment_object.budget_code ? timecard.assignment_object.budget_code : '';
            this.selected_fringe_code = timecard.assignment_object && timecard.assignment_object.fringe_code ? timecard.assignment_object.fringe_code : '';
            this.selected_free_field = timecard.assignment_object && timecard.assignment_object.free_field ? timecard.assignment_object.free_field : '';
            this.selected_free_field2 = timecard.assignment_object && timecard.assignment_object.free_field2 ? timecard.assignment_object.free_field2 : '';
            this.selected_series_code = timecard.assignment_object && timecard.assignment_object.series_code ? timecard.assignment_object.series_code : '';
            this.selected_location_code = timecard.assignment_object && timecard.assignment_object.location_code ? timecard.assignment_object.location_code : '';
            this.selected_set_code = timecard.assignment_object && timecard.assignment_object.set_code ? timecard.assignment_object.set_code : '';
            this.selected_kr_code = timecard.assignment_object && timecard.assignment_object.kr_code ? timecard.assignment_object.kr_code : '';
            this.selected_kr_free_field = timecard.assignment_object && timecard.assignment_object.kr_free_field ? timecard.assignment_object.kr_free_field : '';
            this.selected_kr_free_field2 = timecard.assignment_object && timecard.assignment_object.kr_free_field2 ? timecard.assignment_object.kr_free_field2 : '';
            this.selected_krtax_code = timecard.assignment_object && timecard.assignment_object.krtax_code ? timecard.assignment_object.krtax_code : '';
            this.selected_krtax_free_field = timecard.assignment_object && timecard.assignment_object.krtax_free_field ? timecard.assignment_object.krtax_free_field : '';
            this.selected_krtax_free_field2 = timecard.assignment_object && timecard.assignment_object.krtax_free_field2 ? timecard.assignment_object.krtax_free_field2 : '';
            this.selected_pd_code = timecard.assignment_object && timecard.assignment_object.pd_code ? timecard.assignment_object.pd_code : '';
            this.selected_pd_free_field = timecard.assignment_object && timecard.assignment_object.pd_free_field ? timecard.assignment_object.pd_free_field : '';
            this.selected_pd_free_field2 = timecard.assignment_object && timecard.assignment_object.pd_free_field2 ? timecard.assignment_object.pd_free_field2 : '';
            this.selected_pd_taxable_code = timecard.assignment_object && timecard.assignment_object.pd_taxable_code ? timecard.assignment_object.pd_taxable_code : '';
            this.selected_pdtax_free_field = timecard.assignment_object && timecard.assignment_object.pdtax_free_field ? timecard.assignment_object.pdtax_free_field : '';
            this.selected_pdtax_free_field2 = timecard.assignment_object && timecard.assignment_object.pdtax_free_field2 ? timecard.assignment_object.pdtax_free_field2 : '';
            this.selected_lodging_code = timecard.assignment_object && timecard.assignment_object.lodging_code ? timecard.assignment_object.lodging_code : '';
            this.selected_lodging_free_field = timecard.assignment_object && timecard.assignment_object.lodging_free_field ? timecard.assignment_object.lodging_free_field : '';
            this.selected_lodging_free_field2 = timecard.assignment_object && timecard.assignment_object.lodging_free_field2 ? timecard.assignment_object.lodging_free_field2 : '';
            this.selected_lodging_tax_code = timecard.assignment_object && timecard.assignment_object.lodging_tax_code ? timecard.assignment_object.lodging_tax_code : '';
            this.selected_lodging_tax_free_field = timecard.assignment_object && timecard.assignment_object.lodging_tax_free_field ? timecard.assignment_object.lodging_tax_free_field : '';
            this.selected_lodging_tax_free_field2 = timecard.assignment_object && timecard.assignment_object.lodging_tax_free_field2 ? timecard.assignment_object.lodging_tax_free_field2 : '';
            this.selected_pd_advance_code = timecard.assignment_object && timecard.assignment_object.pd_advance_code ? timecard.assignment_object.pd_advance_code : '';
            this.selected_pdadv_free_field = timecard.assignment_object && timecard.assignment_object.pdadv_free_field ? timecard.assignment_object.pdadv_free_field : '';
            this.selected_pdadv_free_field2 = timecard.assignment_object && timecard.assignment_object.pdadv_free_field2 ? timecard.assignment_object.pdadv_free_field2 : '';
            this.selected_mi_code = timecard.assignment_object && timecard.assignment_object.mi_code ? timecard.assignment_object.mi_code : '';
            this.selected_mi_free_field = timecard.assignment_object && timecard.assignment_object.mi_free_field ? timecard.assignment_object.mi_free_field : '';
            this.selected_mi_free_field2 = timecard.assignment_object && timecard.assignment_object.mi_free_field2 ? timecard.assignment_object.mi_free_field2 : '';
            this.selected_phone_allow_code = timecard.assignment_object && timecard.assignment_object.phone_allow_code ? timecard.assignment_object.phone_allow_code : '';
            this.selected_phone_allow_free_field = timecard.assignment_object && timecard.assignment_object.phone_allow_free_field ? timecard.assignment_object.phone_allow_free_field : '';
            this.selected_phone_allow_free_field2 = timecard.assignment_object && timecard.assignment_object.phone_allow_free_field2 ? timecard.assignment_object.phone_allow_free_field2 : '';
            this.selected_cr_code = timecard.assignment_object && timecard.assignment_object.cr_code ? timecard.assignment_object.cr_code : '';
            this.selected_cr_free_field = timecard.assignment_object && timecard.assignment_object.cr_free_field ? timecard.assignment_object.cr_free_field : '';
            this.selected_cr_free_field2 = timecard.assignment_object && timecard.assignment_object.cr_free_field2 ? timecard.assignment_object.cr_free_field2 : '';
            this.selected_agent_code = timecard.assignment_object && timecard.assignment_object.agent_code ? timecard.assignment_object.agent_code :  '';
            this.selected_agent_free_field = timecard.assignment_object && timecard.assignment_object.agent_free_field ? timecard.assignment_object.agent_free_field :  '';
            this.selected_agent_free_field2 = timecard.assignment_object && timecard.assignment_object.agent_free_field2 ? timecard.assignment_object.agent_free_field2 :  '';

            this.defaultLocation = { id: timecard.assignment_object.location_id, name: timecard.assignment_object.location };
            this.isNew = false;
            this.empLocked = true;
            this.perLocked = true;
            // Make read only if employee has already approved
            // console.log ('Status: ' + timecard.status);
            if (parseInt(timecard.payroll_status) > 0 || parseInt(timecard.status) >= 2 || parseInt(timecard.status) === 0) {
                this.cardLocked = true;
            } else if (this.type === 'employee' && (parseInt(timecard.employee_status) > 0 || parseInt(timecard.employer_status) > 0)) {
                this.cardLocked = true;
            } else {
                this.cardLocked = false;
            }
            this.getHistory();
            this.getRelatedTimecards();
            this.checkAllowanceMessage();
        },

        voidTimecard() {
            if (! this.hash) {
                this.createDialog({ "title": "Error", "body": 'This timecard cannot be voided.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            let timecardHash = this.hash; // Needed for scope
            this.createDialog({ "title": "Please Confirm",
                "body": 'Once Voided, the selected timecard(s) will no longer be paid.',
                "buttonNo": true, "buttonNoLabel": "Go Back",
                "buttonYesLabel": "Continue", "buttonYesAction": function() { app.changeApi('void', timecardHash);}
            });
            return true;
        },

        // Common Mixins
        getPreviousTimecard() {
            if (! this.weekEnding || !this.assignment.id) return false;
            this.oasisApi.get(this.endpoints.timecardPrevious + this.assignment.id + '/' + this.parseLuxon(this.weekEndingTime || this.weekEnding).toISO())
                .then(response => {
                    if (response.status == 200 && typeof response.data === 'object') {
                        this.previousTimecard = response.data;
                        if (this.week && !this.week.overrideDay7 && this.isNew) {
                            // new timecard case
                            if (this.assignment.union_local_id && this.enableWorkDay) {
                                this.week.overrideDay7 = this.assignment.work_day ? this.assignment.work_day == 0 ? null : this.assignment.work_day : null;
                            } else if (this.previousTimecard && this.previousTimecard.timecard_object && this.previousTimecard.timecard_object.overrideDay7) {
                                // set new overrideDay7 value
                                this.week.overrideDay7 = this.previousTimecard.timecard_object.overrideDay7;
                            }
                        } else if (this.week && !this.perLocked) {
                            // when user changed weekending date.
                            if (this.assignment.union_local_id && this.enableWorkDay) {
                                this.week.overrideDay7 = this.assignment.work_day ? this.assignment.work_day == 0 ? null : this.assignment.work_day : null;
                            } else if (this.previousTimecard && this.previousTimecard.timecard_object) {
                                if (this.previousTimecard.timecard_object.overrideDay7) this.week.overrideDay7 = this.previousTimecard.timecard_object.overrideDay7;
                                else this.week.overrideDay7 = null;
                            }
                        }
                    }
                })
                .catch(error => { console.log(error); });
        },

        getHistory() {
            if (! this.assignment || !this.assignment.id || !this.endpoints.history) return false;
            this.oasisApi.get(this.endpoints.history + this.hash)
                .then(response => {
                    if (response.status == 200 && typeof response.data === 'object') {
                        this.history = response.data;
                    }
                })
                .catch(error => { console.log(error); });
        },

        getReviews() {
            if (!this.hash || !this.endpoints.reviews) return false;
            this.oasisApi.get(this.endpoints.reviews + this.hash)
                .then(response => {
                    if (response.status == 200 && typeof response.data === 'object') {
                        this.reviews = response.data.results;
                    }
                })
                .catch(error => { console.log(error); });
        },

        async getRelatedTimecards() {
            if (! this.endpoints.timecardRelated || ! this.hash || ! this.weekEndingTime) return;
            const url = `${this.endpoints.timecardRelated}${this.hash}?week_ending=${this.formatted_week_ending}`;
            // console.log('getRelatedTCs', this.hash, weekEnding)
            const response = await this.oasisApi.get(url);
            if (response.status == 200 && typeof response.data === 'object') {
                this.relatedTimecards = response.data.results;
                return response.data.results;
            } else {
                this.relatedTimecards = undefined;
                return
            }
        },

        async getPreviousTotals() {
            if (! this.endpoints.assignmentTotals || ! this.assignment.id) return;
            const url = `${this.endpoints.assignmentTotals}?assignment_id=${this.assignment.id}`;
            const response = await this.oasisV3Api.get(url);
            if (response.status == 200 && typeof response.data === 'object') {
                // console.log(response);
                this.assignmentTotals = response.data;
                return response.data || {};
            } else {
                return {};
            }
        },

        async getPreviousApprovals() {
            if (this.type === 'employee' || !this.endpoints.tcApproval) return false;
            try {
                const response = await this.oasisV3Api.get(this.endpoints.tcApproval + this.hash);
                if (response.status == 200 && typeof response.data === 'object') {
                    this.previousApprovals = response.data.results;
                }
            } catch (error) {
                console.log(error);
            }
        },
 
        // Determine if any capped amounts are reached
        checkAllowanceCaps(totals = null) {
            if (!this.assignmentTotals && !totals) return;
            const assignmentTotals = totals || this.assignmentTotals;

            let message = '';

            message += this.compareAllowanceCap('Kit Rental NT', 'kit_rental', 'kitRental', this.assignment.kr_cap, assignmentTotals);
            message += this.compareAllowanceCap('Kit Rental Tax', 'kit_rental_tax', 'kitRentalTax', this.assignment.krtax_cap, assignmentTotals);
            message += this.compareAllowanceCap('Phone Allowance', 'phone_allow', 'phoneAllow', this.assignment.phone_cap, assignmentTotals);
            message += this.compareAllowanceCap('Car Rental', 'car_rental', 'carRental', this.assignment.cr_cap, assignmentTotals);

            if (message) this.important_message = message;
        },

        // Look at individual allowances
        compareAllowanceCap(label, fieldName, brokenName, cap, assignmentTotals) {
            if (!label, !fieldName || !cap || !assignmentTotals || !assignmentTotals[fieldName]) return '';
            if (!brokenName) brokenName = fieldName;
            let message = '';

            if (typeof cap !== 'number') cap = parseFloat(cap);
            const current = parseFloat(this.brokenHours.week.allowances[brokenName] || 0);
            const previous = parseFloat(assignmentTotals[fieldName]) - current;
            const pending = current ? 0 : parseFloat(this.assignment[fieldName]); // Uncalc'd amount

            if (previous > cap) {
                // The cap was reached before this timecard
                message = `The ${label} cap of ${cap} has been reached on an earlier payroll.  Please update the start in order to avoid this warning.<br />`;
                // this.onAllowanceOverrideChange(0, fieldName, 'amount');
            } else if ((current + previous) > cap) {
                // The cap has been reached with this timecard
                const overage = (current + previous) - cap;
                message = `The ${label} cap of ${cap} is now over by $${overage}. Please adjust.<br />`;
            } else if ((pending + previous) > cap) {
                // The cap will be reached with this timecard
                const overage = (pending + previous) - cap;
                message = `The ${label} cap of ${cap} will be exceeded with this calculation. <br />`;
            }

            return message;
        },

        getEmployee(employeeId = null) {
            if (!employeeId && !this.assignment.employee_id) {
                return null;
            } else if (!employeeId) {
                employeeId = this.assignment.employee_id;
            }

            this.oasisApi.get(this.endpoints.employee + '/' + employeeId)
            .then(response => {
                if (response.status == 200 && typeof response.data === 'object') {
                    this.employeeObject = response.data;
                }
            })
            .catch(error => { console.log(error); });
        },

        // Check form and if there was a timecard last week
        async preCalcCheck(fromEmployeeSign = false) {
            // Close modals
            this.timecardDocModal = false;
            this.kickbackModal = false;
            this.kickbackApproverModal = false;
            this.overridePenaltyModal = false;
            this.adjustmentModal = false;
            this.unionScheduleModal = false;

            let response = '';
            let batchInfo = '';
            if (this.batch_id) {
                response = await this.oasisApi.get(`/batches/${this.batch_id}`);
                batchInfo = response.data;
            }
            if (this.showBatches && this.batch_id && batchInfo.results && batchInfo.results[0].signatory_name) {
                let wasChanged = false;
                if (response && batchInfo) {
                    // check whether department_id was changed or not
                    let batDept = batchInfo.results[0].department_id ? batchInfo.results[0].department_id : null;
                    let assDept = this.assignment.department_id ? this.assignment.department_id : null;
                    if (batDept != null && batDept != assDept) {
                        wasChanged = true;
                    }
                    // check whether week_ending was changed or not
                    if (!wasChanged && new Date(this.weekEnding).toISOString().split('T')[0] != new Date(batchInfo.results[0].week_ending).toISOString().split('T')[0]) {
                        wasChanged = true;
                    }

                    // union check
                    if (!wasChanged) {
                        let batUnion = batchInfo.results[0].is_union == 1 ? true : false;
                        let assUnion = this.assignment.flsa_type_id == 3 ? true : false;
                        if (batUnion != assUnion) {
                            wasChanged = true;
                        }
                    }

                    //signatory check
                    if (!wasChanged) {
                        const assignmentSig = await this.getSignatory();
                        let assSig = assignmentSig ? assignmentSig : null;
                        let batSig = batchInfo.results[0].signatory_name ? batchInfo.results[0].signatory_name : null;
                        if (assSig != batSig) {
                            wasChanged = true;
                        }
                    }
                }
                if (wasChanged) {
                    ((this.$refs['batch_id'] || {}).classList || {}).add('form-error');
                    this.createDialog({ "title": "Warning", "body": "The timecard does not match the batch Weekending, Union/Non union, Department, and/or Signatory. Please assign to a new batch.", "buttonNo": false, "buttonYesLabel": "OK" });
                    return false;
                }
                else {
                    ((this.$refs['batch_id'] || {}).classList || {}).remove('form-error');
                }
            }

            // If we are splitting by signatories, need to add a project to all day types that may have pay
            if (this.showProjects && typeof this.useSignatories !== 'undefined' && this.useSignatories) {
                for (const dayNum in this.week) {
                    const day = this.week[dayNum];
                    if (!day || typeof day !== 'object' || typeof day.day_type === 'undefined') continue;

                    if (!day.project && (day.time_2 || ![ 'nowork', 'unpaid' ].includes(day.day_type))) {
                        this.createDialog({ "title": "Warning", "body": "Please select a Project for each worked/paid day.", "buttonNo": false, "buttonYesLabel": "OK" });
                        return false;
                    }
                }
                for (const dayNum in this.week2) {
                    const day = this.week2[dayNum];
                    if (!day || typeof day !== 'object' || typeof day.day_type === 'undefined') continue;

                    if (!day.project && (day.time_2 || ![ 'nowork', 'unpaid' ].includes(day.day_type))) {
                        this.createDialog({ "title": "Warning", "body": "Please select a Project for each worked/paid day.", "buttonNo": false, "buttonYesLabel": "OK" });
                        return false;
                    }
                }
            }

            // Quick check 
            if ($(".form-error").length > 0) {
                if (fromEmployeeSign === true) this.createDialog({ "title": "Error", "body": 'Please fix errors before signing.', "buttonNo": false, "buttonYesLabel": "OK" });
                else this.createDialog({ "title": "Error", "body": 'Please fix errors before calculating.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            } else if (this.employee === '') {
                this.createDialog({ "title": "Error", "body": 'Please enter an employee and time before calculating pay.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            this.checkAllowanceCaps();

            // Disable warnings for now.
            if (fromEmployeeSign === true) await this.calc({hideDialog: true});
            else this.calc();
            return true;
        },

        copyPrevious(times) {
            if (!this.employee.name) {
                this.createDialog({ "title": "Error", "body": 'Please Select an Employee First.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            } else if (!this.weekEnding) {
                this.createDialog({ "title": "Error", "body": 'Please Select an Week Ending First.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }

            //If bi-weekly, add to week2
            const prevTimes2 = (this.previousTimecard || {}).timecard_object2 || null;
            // console.log(this.previousTimecard.timecard_object2.day_2)
            // console.log(prevTimes2)
            if (prevTimes2) {
                this.week2 = Object.assign({}, prevTimes2);
            }

            const prevTimes = (times || {}).day_1 ? times : ((this.previousTimecard || {}).timecard_object || null);
            // console.log(this.previousTimecard.timecard_object.day_2)
            // console.log(prevTimes)
            if (! prevTimes) {
                this.createDialog({ "title": "Alert", "body": "No previous timecard found", "buttonNo": false, "buttonYesLabel": "OK"  });
            } else {
                this.modified = true;
                let localTimezone = parseInt(this.timezone_entered || this.timezone_local || this.previousTimecard.timezone_entered);
                if (localTimezone !== parseInt(this.previousTimecard.timezone_entered)) {
                    const tzOffset = parseInt(this.timezone_local) - parseInt(this.previousTimecard.timezone_entered);
                    const fixTimes = [ 'time_1', 'time_2', 'time_3', 'time_4', 'time_5', 'time_6', 'time_7', 'time_8', 'time_9', 'time_10', 'time_11', 'time_12', ]
                    for (const day in prevTimes) {
                        const data = prevTimes[day];
                        for (const time in data) {
                            if (data.hasOwnProperty(time) && data[time] && fixTimes.includes(time)) {
                                try {
                                    const datetime = new Date(data[time]);
                                    const adjustedDate = new Date(datetime.getTime() + (60000 * tzOffset));
                                    prevTimes[day][time] = adjustedDate.toISOString();
                                } catch (error) {
                                    this.$emit('message', error);
                                    continue;
                                }
                            }
                        }
                    }
                }
                this.week = Object.assign({}, prevTimes);
                this.updateDays(this.weekEnding);
                this.perLocked = true;
            }
        },

        importSchedule(weekData) {
            this.unionScheduleModal = false;
            if (!this.employee.name) {
                this.createDialog({ "title": "Error", "body": 'Please Select an Employee First.', "buttonNo": false, "buttonYesLabel": "OK" });
                return false;
            }
            let day = 1, times = {};
            for (const i in weekData){
                times['day_' + day] = {};

                const importedDay = weekData[i];
                if (!importedDay) {
                    day++;
                    continue;
                }

                // console.log(importedDay);
                if (importedDay && importedDay.time_1) times['day_' + day].time_1 = new Date(importedDay.time_1);
                if (importedDay && importedDay.time_2) times['day_' + day].time_2 = new Date(importedDay.time_2);
                if (importedDay && importedDay.time_3) times['day_' + day].time_3 = new Date(importedDay.time_3);
                if (importedDay && importedDay.time_4) times['day_' + day].time_4 = new Date(importedDay.time_4);
                if (importedDay && importedDay.time_5) times['day_' + day].time_5 = new Date(importedDay.time_5);
                if (importedDay && importedDay.time_6) times['day_' + day].time_6 = new Date(importedDay.time_6);
                day++;
            }

            this.copyPrevious(times);
        },

        async batchCheck(batchId) {
            ((this.$refs['batch_id'] || {}).classList || {}).remove('form-error');
            if(batchId === 'addBatch') {
                this.newBatch.signatory_name = await this.getSignatory();
                this.autoGenerateNewBatchName();
                this.batchModal = true;
                $("#addBatchForm input[name='name']").focus();
            } else {
                this.batch_id = batchId;
                this.batch = this.batches.find((bat) => bat.id == batchId).name;
                // for not brand new timecard, If user change batch, will be saved automatically right away, so we don't need to set modified true, but on new timecard, we need to set.
                if (! this.timecard_id && ! this.modified) this.modified = true;
                if (this.timecard_id && ! this.isRefreshStart) {
                    // we need to block this case that if user refresh start then change batch and close timecard before save timecard - data will be different btw timecard and batch
                    let data = {id: this.timecard_id, isBatchUpdate: true, batch_id: this.batch_id ? this.batch_id : null};
                    let res = await this.oasisApi.patch('/timecard', data);
                    if (res && (res.status == 200 || res.status == 201)) {
                        this.createDialog({ "title": "Success", "body": 'Batch Saved' , "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                }
            }
        },

        closeBatchModal() {
            this.batchModal = false;
        },

        // Add a new department to the current entity
        addBatch() {
            if (this.checkForm("#addBatchForm")) {
                // console.log ('Adding batch');
                let method = this.newBatch.id ? 'patch' : 'post';

                this.newBatch.week_ending = DateTime.fromFormat(this.weekEnding, this.format).toFormat('yyyy-MM-dd');
                this.newBatch.entity_id = (this.assignment || {}).entity_id || null;
                this.newBatch.department_id = this.newBatch.department_id ? this.newBatch.department_id : null;
                this.newBatch.union_local_id = (this.assignment || {}).union_local_id || null;
                this.newBatch.is_union = this.newBatch.union_local_id ? 1 : 0;
                this.newBatch.signatory_name = this.newBatch.signatory_name ? this.newBatch.signatory_name : null;

                this.oasisApi[method]('/batches', this.newBatch)
                    .then(response => {
                        if (response.status == 200 || response.status == 201) {
                            this.batchModal = false;
                            if (response.data.count === 1) {
                                return response.data.results[0];
                            }
                            else return false;
                        } else if (response.status == 400 || response.status == 422 || response.status == 403) {
                            // permission error will be 403 but It's object.
                            if (Array.isArray(response.data.errorMessages)) {
                                const errorMessages = response.data.errorMessages;
                                let message = '';
                                for (const i in errorMessages) {
                                    if (typeof errorMessages[i].message !== 'string') continue;
                                    $("#addBatchForm input[name='" + errorMessages[i].field + "']").addClass('form-error2');
                                    message += (errorMessages[i].message + "\n") || '';
                                }
                                this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                            } else {
                                this.createDialog({ "title": "Error", "body": response.data.message || 'Error adding the field.', "buttonNo": false, "buttonYesLabel": "OK"  });
                            }
                            return false;
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data , "buttonNo": false, "buttonYesLabel": "OK" });
                            return false;
                        }
                    })
                    .then(async (result) => {
                        if (!result) return false;
                        // Refresh
                        await this.getBatches();
                        this.batch = result.name;
                        this.batch_id = result.id;
                        // for not brand new timecard, If user change batch, will be saved automatically right away, so we don't need to set modified true, but on new timecard, we need to set.
                        if (! this.timecard_id && ! this.modified) this.modified = true;
                        if (this.timecard_id && ! this.isRefreshStart) {
                            let data = {id: this.timecard_id, isBatchUpdate: true, batch_id: this.batch_id};
                            let res = await this.oasisApi.patch('/timecard', data);
                            if (res && (res.status == 200 || res.status == 201)) {
                                this.createDialog({ "title": "Success", "body": 'Batch Saved' , "buttonNo": false, "buttonYesLabel": "OK"  });
                            }
                        }

                    })
                    .catch(error => {
                        console.log('error: '); console.log(error); 
                    });
            }
        },

        changeApi(type, selected) {
            if (!type || ! selected) return false;

            let apiEndpoint;
            if (type === 'void') {
                apiEndpoint = '/bulkchange/timecard/void';
            } else if (type === 'unfinalize') {
                apiEndpoint = '/bulkchange/timecard/unfinalize';
            } else if (type === 'adjust') {
                apiEndpoint = '/bulkchange/timecard/adjust';
            } else {
                return false;
            }

            let data = {
                timecards: [ selected ],
                message: this.employerMessage,
            };

            this.waiting = true;

            this.oasisApi.patch(apiEndpoint, data)
                .then(response => {
                    // console.log (response);
                    if (response.status == 200){
                        this.createDialog({ "title": "Success", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK", "buttonYesAction": function () { location.reload()} });

                    } else if (response.status == 400) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                        } else if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                    this.waiting = false;
                })
                .catch(error => {
                    console.log('error: '); console.log(error); alert (error);
                    this.waiting = false;
                })
            ;
        },

        clone() {
            this.modified = true;
            this.perLocked = false;
            this.cardLocked = false;
            this.timecard_id = '';
        },

        changeWE() {
            this.modified = true;
            this.perLocked = false;
        },

        overrideMPs() {
            for (const i in this.brokenHours) {
                let day = this.brokenHours[i]
                if (! day.hasOwnProperty('penalty_meal_1')) {
                    day.penalty_meal_1 = { value: 0, pay: 0 };
                }
                if (! day.hasOwnProperty('penalty_meal_2')) {
                    day.penalty_meal_2 = { value: 0, pay: 0 };
                }
            }

            if (this.timecardType === 'biweekly') {
                for (const i in this.brokenHours2) {
                    let day = this.brokenHours2[i]
                    if (! day.hasOwnProperty('penalty_meal_1')) {
                        day.penalty_meal_1 = { value: 0, pay: 0 };
                    }
                    if (! day.hasOwnProperty('penalty_meal_2')) {
                        day.penalty_meal_2 = { value: 0, pay: 0 };
                    }
                }
            }
            this.overridePenaltyModal = true;
        },

        showError(message) {
            if (! message) return false;
            else {
                if (this.error_message && !this.error_message.includes(message)) {
                    message = `${this.error_message} <br> ${message}`;
                }
                this.error_message = message;
            }
        },

        showAccrual(type) {
            if (! type) return false;
            else {
                this.checkAccrual(type)
                    .then(response => {
                        this.accruals[type].balance = this.round(response);
                        if (response && response > 0) this.accruals[type].visible = true;
                    })
                    .catch(error => {
                        this.accruals[type].visible = false;
                    })
            }
        },

        checkAccrual(type) {
            return new Promise((resolve, reject) => {
                if (! type || ! this.assignment.hash) {
                    return reject(false);
                }

                this.oasisApi.get(this.endpoints.accrual +  type + '/' + this.assignment.hash)
                    .then(response => {
                        let hours = '0.00';
                        if (response.status === 200) {
                            hours = response.data;
                        } else {
                        }
                        return resolve (hours);
                    })
                    .catch(error => {
                        return reject (error);
                    }
                );
            });
        },

        unlockCard () {
            this.empLocked = false;
            this.cardLocked = false;
        },

        // Retreive Minimum wage data based on the available factors
        checkMinWage() {
            if (this.type === 'employee') return false;
            // California Minimum wage applies to residents working out of state as well
            // Use a hard-coded location that's in california
            let unionJurisdiction;
            if (this.union && this.assignment.job_title_id && this.assignment.union_hired_from_id == 79) {
                unionJurisdiction = 1;
            } else {
                unionJurisdiction = this.assignment.union_jurisdiction_id || null;
            }

            // Is this from complete?  If so, the value should be the assignment id lookup the employee
            var options = {};
            if (! this.assignment.hourly_rate) {
                options = {
                    rate_unit_id: this.assignment.rate_unit_id,
                    rate: this.assignment.rate,
                    location_id: this.assignment.location_id,
                    agreement_id: this.assignment.agreement_id,
                    union_local_id: this.assignment.union_local_id,
                    job_title_id: this.assignment.job_title_id,
                    legislative_type_id: this.assignment.legislative_type_id,
                    resident_state_id: this.assignment.resident_state_id,
                    union_jurisdiction_id: unionJurisdiction,
                    union_schedule_id: this.assignment.union_schedule_id,
                    union_hired_from_id: this.assignment.union_hired_from_id
                }
            } else {
                options = {
                    rate_unit_id: 1,
                    rate: this.assignment.hourly_rate,
                    location_id: this.assignment.location_id,
                    agreement_id: this.assignment.agreement_id,
                    union_local_id: this.assignment.union_local_id,
                    job_title_id: this.assignment.job_title_id,
                    legislative_type_id: this.assignment.legislative_type_id,
                    resident_state_id: this.assignment.resident_state_id,
                    union_jurisdiction_id: unionJurisdiction,
                    union_schedule_id: this.assignment.union_schedule_id,
                    union_hired_from_id: this.assignment.union_hired_from_id
                }
            }

            this.oasisApi.post('/minimumWage', options)
                .then(response => {
                    // console.log ('Checking Minimum Wage');
                    // console.log (response.data.scale);
                    return response.data;
                })
                .then(minWage => {
                    let defaultScale, newScale, newScaleStartDate
                    if (minWage.isBelow === true && new Date(minWage.date_start) < new Date(this.weekEnding)) {
                        this.important_message += 'The minimum wage has recently changed to $' + parseFloat(minWage.minimum).toFixed(2) + '. Please update the employee pay rate and choose "<em>Refresh Start Data</em>" from the "<em>More</em>" menu in this timecard to apply the new pay rate.<br />';
                    }
                    if (minWage.scale && new Date(minWage.scale.date_start) < new Date(this.weekEnding)) {
                        newScale = minWage.scale.scale;
                        newScaleStartDate = new Date(minWage.scale.date_start);
                        if (parseFloat(minWage.scale * 1) > parseFloat(this.assignment.hourly_rate)) {
                            this.important_message += 'As of ' + minWage.scale.date_start + ' scale will be $' + parseFloat(minWage.scale.scale).toFixed(2) + '. Please adjust your pay accordingly.<br />';
                        }
                    }

                    // add scale to week object for payroll calcs
                    if (minWage.scale) { 
                        defaultScale = this.assignment.scale_rate;
                        for (const day in this.week) {
                            if (day && !day.match(/^day_/)) continue;
                            if (newScale && newScaleStartDate && new Date(this.week[day].date.full) >= newScaleStartDate) {
                                this.week[day].scale_rate = newScale; // TODO oncall
                            } else {
                                this.week[day].scale_rate = defaultScale;
                            }
                        }
                    }
                })
                .catch(error => { console.log(error); }
            );
        },

        async checkStartStatus() {
            if (!this.assignment.hash) return false;

            let result;
            try {
                const response = await this.oasisApi.get(this.endpoints.assignment + '/' + this.assignment.hash);
                if (response.status !== 200 || typeof response.data !== 'object') return false;
                result = response.data;
            } catch (error) {
                this.$emit('message', error);
                return false;
            }

            if (this.type === 'employee') {
                if (parseInt(result.employee_status) < 1) {
                    this.important_message += 'Your start paperwork has not been filled out. Please click here to complete your start.<br />';
                } else if (parseInt(result.employee_status) < 2) {
                    this.important_message += 'Your start paperwork has not been approved. Please click here to complete your start.<br />';
                }
                return;
            }

            if (parseInt(result.employee_status) < 2) {
                this.important_message += 'This start has not been signed by the employee.<br />';
            }
            if (parseInt(result.status) < 6 || parseInt(result.employer_status) < 2) {
                this.important_message += 'This start has not been fully approved by all approvers.<br />';
            } else if (this.isI9Needed && (! result.i9_verified_date && parseInt(result.paper_form || 0) === 0)) {
                this.important_message += 'The I-9 has not been verified for this employee.';
            }

            // Check allowance caps
            await this.getPreviousTotals();
            this.checkAllowanceCaps();
        },

        loadTCList(tcHashes = null) {
            if (!tcHashes) {
                const local = JSON.parse(localStorage.getItem('timecardList'));
                if (! local) return false;
                else tcHashes = local;
            }

            this.timecardList = tcHashes;
        },

        gotoNextTc() {
            if (! this.nextTimecard) return false;
            window.location.href = '/oasis/timecard/create/' + this.nextTimecard;
        },

        gotoPrevTc() {
            if (! this.prevTimecard) return false;
            window.location.href = '/oasis/timecard/create/' + this.prevTimecard;
        },

        async getBatches() {
            // batch function is not related to employee timecard page.
            if (type === 'employee') return;
            let filterString = `?status=1&week_ending=${this.formatted_week_ending}`;
            if (this.assignment.union_local_id) {
                filterString += `&is_union=1`;
            }
            else {
                filterString += `&is_union__lt=1`;
            }
            if (this.assignment.department_id) {
                filterString += `&department_id__nulloreq=${this.assignment.department_id}`;
            }
            else {
                filterString += `&department_id=null`;
            }
            const signatoryName = await this.getSignatory();
            if (signatoryName) {
                filterString += `&signatory_name=${signatoryName}`;
            }
            const response = await this.oasisApi.get('/batches' + filterString);
            let newBatches = (response.data || {}).count > 0 ? response.data.results : [];
            this.batches = newBatches;
            return this.batches;
        },

        async getProjects() {
            const response = await this.oasisApi.get('/projects');
            this.allProjects = response.data || this.allProjects;
        },

        async getAssignedProjects() {
            const response = await this.oasisApi.get(`/assignedProjects/${this.assignment.id}`);
            // console.log(response);
            this.assignedProjects = response.data;
            return this.assignedProjects;
        },

        closeProjectModal() {
            this.projectModal = false;
        },

        // Add a new project to the current entity
        addProjectCheck(day) {
            this.projectModal = true;
            if (day) this.newProject.day = day;
            $("#addProjectForm input[name='name']").focus();
        },
        addProject() {
            if (this.checkForm("#addProjectForm")) {
                // console.log ('Adding project');
                this.newProject.entity_id = (this.assignment || {}).entity_id || null;

                let method = this.newProject.id ? 'patch' : 'post';
                this.oasisApi[method]('/projects', this.newProject)
                    .then(response => {
                        if (response.status == 200 || response.status == 201) {
                            this.projectModal = false;
                            this.newProject = {
                                name: '',
                                code: '',
                                description: '',
                                signatory_number: '',
                            }
                            if (response.data.id) {
                                return response.data.id
                            }
                            else return false;
                        } else if (response.status == 400 || response.status == 422) {
                            if (Array.isArray(response.data.errorMessages)) {
                                const errorMessages = response.data.errorMessages;
                                let message = '';
                                for (const i in errorMessages) {
                                    if (typeof errorMessages[i].message !== 'string') continue;
                                    $("#addProjectForm input[name='" + errorMessages[i].field + "']").addClass('form-error2');
                                    message += (errorMessages[i].message + "\n") || '';
                                }
                                this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK"  });
                            } else {
                                this.createDialog({ "title": "Error", "body": response.data.message || 'Error adding the field.', "buttonNo": false, "buttonYesLabel": "OK"  });
                            }
                            return false;
                        } else {
                            this.createDialog({ "title": "Alert", "body": response.data , "buttonNo": false, "buttonYesLabel": "OK" });
                            return false;
                        }
                    })
                    .then(async (result) => {
                        if (!result) return false;
                        // Refresh
                        await this.getProjects();
                    })
                    .catch(error => {
                        console.log('error: '); console.log(error); 
                    });
            }
        },

        addOtherPay(e) {
            e.stopPropagation();

            if (!this.newOtherPay.type_id || !this.newOtherPay.pay) {
                this.createDialog({ "title": "Error", "body": 'Please entry a pay type and amount.', "buttonNo": false, "buttonYesLabel": "OK" });
                return 
            }

            if (!this.checkForm("#addOtherPayForm", false)) {
                this.createDialog({ "title": "Error", "body": 'Remove unsupported characters such as letters or $ to proceed', "buttonNo": false, "buttonYesLabel": "OK" });
                return 
            }

            // Take newOtherPay data and add to assignment.additional_allowances
            let selectedOtherPay = this.otherPayTypes.find(({id}) => parseInt(id) === parseInt(this.newOtherPay.type_id));

            if (typeof this.assignment.additional_allowances !== 'object') {
                this.assignment.additional_allowances = {};
            }

            this.newOtherPay.name = selectedOtherPay.name;
            this.newOtherPay.properties = selectedOtherPay.value ? JSON.parse(selectedOtherPay.value) : {};
            this.newOtherPay.code = selectedOtherPay.code;
            this.newOtherPay.pay = (parseFloat(this.newOtherPay.pay || '0') || 0).toFixed(2);

            // Allow repeats of allowance by disabling this code
            this.assignment.additional_allowances[selectedOtherPay.code + Math.random()] = Object.assign({}, this.newOtherPay);

            // Reset newOtherPay
            this.newOtherPay = {
                name: '',
                code: '',
                type_id: null,
                description: '',
                pay: null,
                budget_code: this.assignment.budget_code,
                fringe_code: this.assignment.fringe_code,
                series_code: this.assignment.series_code,
                location_code: this.assignment.location_code,
                set_code: this.assignment.set_code,
                free_field: this.assignment.free_field,
                free_field2: this.assignment.free_field2,
            };

            this.showOtherPay = true;
            this.otherPayModal = false;
            this.modified = true;
        },

        // Not implemented yet.
        removeOtherPay(code) {
            if (code) {
                // console.log(code, this.assignment.additional_allowances, this.assignment.additional_allowances[code]);
                delete this.assignment.additional_allowances[code];
            }
        },

        closeOtherPayModal() {
            this.otherPayModal = false;
        },

        onSelectOtherPay(event) {
            if (!event || !event.target || !event.target.value) {
                return
            }

            const selectedOtherPay = this.otherPayTypes.find(({id}) => parseInt(id) === parseInt(this.newOtherPay.type_id));
            const payProps = JSON.parse(selectedOtherPay.value || '{}')

            if (this.assignment.additional_allowances.hasOwnProperty(selectedOtherPay.code)) {
                this.createDialog({ "title": "Error", "body": 'This pay type already exists. Please edit the pay directly.', "buttonNo": false, "buttonYesLabel": "OK" });
            } else if (!this.newOtherPay.pay && selectedOtherPay && (payProps || {}).default_pay) {
                this.newOtherPay.pay = payProps.default_pay;
            }
        },

        // pad 1-digit months/days
        pad(n) {
            return n < 10 ? '0' + n : n;
        },

        round(n) {
            if (isNaN(n)) return false;
            return (Math.round(n*100)/100).toFixed(2);
        },

        // Create a dynamic modal dialog box with buttons and labels
        createDialog(options) {
            let index = this.openModals;
            options.id = index;

            if (options.buttonYesAction) { this.buttonYesAction[index] = options.buttonYesAction;
            } else { this.buttonYesAction[index] = function () {}; }

            if (options.buttonYesLabel) { this.buttonYesLabel = options.buttonYesLabel;
            } else { options.buttonYesLabel = 'Yes'; }

            if (options.buttonNoAction) { this.buttonNoAction[index] = options.buttonNoAction;
            } else { this.buttonNoAction[index] = function () {}; }

            if (options.buttonNoLabel) { this.buttonNoLabel = options.buttonNoLabel;
            } else { options.buttonNoLabel = 'No'; }

            if (options.button3Action) { this.button3Action[index] = options.button3Action;
            } else { this.button3Action[index] = function () {}; }

            if (options.button3Label) { this.button3Label = options.button3Label;
            } else { options.button3Label = 'Maybe'; }

            // console.log ("Modal Creation: " + this.openModals);
            this.modals.push(options);
            this.openModals++;
        },

        // Close the dynamic modal
        closeModal(index) {
            // console.log ('Modal Close: ' + index)
            this.modals.splice(index, 1);
            this.buttonYesAction.splice(index, 1);
            this.buttonNoAction.splice(index, 1);
            this.button3Action.splice(index, 1);
            this.openModals--;
        },

        modalConfirm(index) {
            // console.log ('Modal Confirm: ' + index)
            this.buttonYesAction[index]();
        },

        modalCancel(index) {
            // console.log ('Modal Cancel: ' + index)
            this.buttonNoAction[index]();
        },

        modalButton3(index) {
            // console.log ('Modal Button3: ' + index)
            this.button3Action[index]();
        },

        cancelCurrent(event) {
            this.createDialog({ "title": "Are You Sure?", "body": "You will lose any unsaved work.  Proceed?",
                "buttonYesAction": function () { window.location.href = this.endpoints.dashboard },
            });
        },

        // Easy validation, e.g. if fields are required
        checkForm(form, useErrMeg = true) {
            if (form) {
                var scope = [ form + " input", form + " select" ];
            } else {
                var scope = [ "input", "select" ];
            }

            $.each(scope, function (index, value) {
                $(value).filter(".form-error2").each(function(ind, field){
                    $(field).removeClass("form-error2");
                });

                $(value).filter("[required]:visible").each(function(ind, field){
                    $(field).removeClass("form-missing");

                    if ($(field).val() == "") {
                        $(field).addClass("form-missing");
                    } else {
                        $(field).removeClass("form-missing");
                    }
                });
            });

            if ($(".form-missing").length > 0) {
                if (useErrMeg) this.createDialog({ "title": "Warning", "body": 'Please add missing data before submitting.', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            } else if ($(".form-error").length > 0) {
                if (useErrMeg) this.createDialog({ "title": "Warning", "body": 'Please fix errors before submitting.', "buttonNo": false, "buttonYesLabel": "OK"  });
                return false;
            } else {
                return true;
            }
        },

        setModified() {
            this.modified = true;
        },

        closeWindow() {
            window.close()
        },

        leavePage(e) {
            if (app.modified == true){
                // console.log ('Modified');
                var confirmationMessage = 'This timecard has been modified. If you quit before saving, your changes will be lost.';

                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
            } else {
                // console.log ('Not Modified');
                return undefined;
            }
        },

        fringeCheck(selectedData) {
            // if we got error case, this function will not be fired.
            let val = ''
            if (selectedData && selectedData.code) {
                val = selectedData.code;
                const setFringe = selectedData.code.substring(0,selectedData.code.length-2) + '99';
                let validate = this.probooksAccounts.findIndex((el) => { return el.code == setFringe });

                if (validate == -1) {
                    this.assignment.fringe_code = '';
                    this.selected_fringe_code = '';
                } else if (selectedData.code.length < 4) {
                    this.assignment.fringe_code = '';
                    this.selected_fringe_code = '';
                } else {
                    this.assignment.fringe_code = setFringe;
                    this.selected_fringe_code = setFringe;
                }
            } else if (selectedData) {
                // this case would be custom data instead of selection. (if we set mustMatch = false, we will get this case)
                val = selectedData;
            }

            this.modified = true;
            this.assignment.budget_code = val;

            return;
        },

        setFringe(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.fringe_code = val;
            return;
        },

        setFF1(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.free_field = val;
            return;
        },

        setFF2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.free_field2 = val;
            return;
        },

        setSeries(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.series_code = val;
            return;
        },

        setLocation(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.location_code = val;
            return;
        },

        setSet(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.set_code = val;
            return;
        },
        set_agent_code(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.agent_code = val;
            return;
        },

        set_agent_free_field(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.agent_free_field = val;
            return;
        },

        set_agent_free_field2(selectedData) {
            let val = ''
            if (selectedData && selectedData.code) val = selectedData.code;
            else if (selectedData) val = selectedData;

            this.modified = true;
            this.assignment.agent_free_field2 = val;
            return;
        },

        selectOtherPayAccountCoding(selectedData, name) {
            let val = ''
            if (name == 'budget_code') {
                if (selectedData && selectedData.code) {
                    val = selectedData.code;
                    const setFringe = selectedData.code.substring(0,selectedData.code.length-2) + '99';
                    let validate = this.probooksAccounts.findIndex((el) => { return el.code == setFringe });

                    if (validate == -1) {
                        this.newOtherPay.fringe_code = '';
                    } else if (selectedData.code.length < 4) {
                        this.newOtherPay.fringe_code = '';
                    } else {
                        this.newOtherPay.fringe_code = setFringe;
                    }
                } else if (selectedData) {
                    val = selectedData;
                }
                this.newOtherPay.budget_code = val;
            } else {
                if (selectedData && selectedData.code) val = selectedData.code;
                else if (selectedData) val = selectedData;
                this.newOtherPay[name] = val;
            }
            this.modified = true;
          },

        highlightChange( {target} ) {
            // do some light validation to check if an `.amount` field contains invalid characters.
            if ($(target).hasClass('amount') && $(target).val() && $(target).val().match(/[^0-9\.]/g, '')) {
                $(target).addClass("form-error");
            } else if ($(target).hasClass('amount') && $(target).hasClass('form-error')) {
                $(target).removeClass("form-error");
            }

            this.setModified();
            return;
        },

        // Expect an event, numeric or string value
        onAllowanceAssignmentChange(event, code) {
            if (code && typeof this.assignment[code] !== 'undefined' && event.code) {
                this.assignment[code] = event.code;
                // console.log('code', event.code, code, this.assignment[code]);
            } else if (code && typeof this.assignment[code] !== 'undefined' && event) {
                this.assignment[code] = event;
            } else if (code && typeof this.assignment[code] !== 'undefined' && event == '') {
                this.assignment[code] = event;
            } else {
                return;
            }
        },

        // Expect a numeric or string value
        onAllowanceOverrideChange(value, prop, code) {
            // console.log('override', value, prop, code, this.overrides);
            if ((value && !isNaN(value)) || value === 0 || value === null) {
                // Allow numeric, 0's and nulls
            } else {
                return;
            }
            // console.log(value)
            if (!code) return;

            // add new fields to existing timecards
            if (typeof this.overrides[prop] === 'undefined') {
                this.overrides[prop] = {}
            }
            this.overrides[prop][code] = value;
            this.checkAllowanceCaps();
        },

        selectAllowanceOtherPayAccountCoding(event,name,allowance) {
            let val = '';
            if (name == 'budget_code') {
                if (event && event.code) {
                    val = event.code;
                    const setFringe = event.code.substring(0,event.code.length-2) + '99';
                    let validate = this.probooksAccounts.findIndex((el) => { return el.code == setFringe });

                    if (validate == -1) {
                        this.assignment.additional_allowances[allowance].fringe_code = '';
                        } else if (event.code.length < 4) {
                        this.assignment.additional_allowances[allowance].fringe_code = '';
                    } else {
                        this.assignment.additional_allowances[allowance].fringe_code = setFringe;
                    }
                } else if (event) {
                    val = event;
                }
                this.assignment.additional_allowances[allowance].budget_code = val;
            } else {
                if (event && event.code) val = event.code;
                else if (event) val = event;
                this.assignment.additional_allowances[allowance][name] = val;
            }
            this.modified = true; // existing behavior
        },

        updateUnionLocation(event) {
            console.log(event);
            if (!this.unionLocations || !Array.isArray(this.unionLocations)) return;
            const id = !isNaN(event) ? event : (((event || {}).target || {}).value || this.assignment.union_location_id);
            this.assignment.union_location = this.unionLocations.find((loc) => parseInt(loc.id) === parseInt(id)).code;
            return;
        },

        loadByHash(hash, checkStartStatus=true, checkMinWage=true) {
            this.oasisApi.get(this.endpoints.timecardLoadByHash + hash)
                .then(response => {
                    if (response.status == 200 && typeof response.data === 'object') {
                        let timecard = response.data;
                        this.newWeekEnding = this.weekEnding = this.weekEndingTime = timecard.week_ending;
                        this.updateAssignment(timecard.assignment_object);
                        this.timecard_id = timecard.id;
                        this.week = this.convertWeekToDateObjects(timecard.timecard_object);
                        this.week2 = this.convertWeekToDateObjects(timecard.timecard_object2) || this.week2;
                        this.brokenHours = timecard.broken_object;
                        this.brokenHours2 = timecard.broken_object2 || this.brokenHours2;
                        this.overrides = typeof timecard.overrides === 'object' ? timecard.overrides : (typeof timecard.overrides === 'string' && this.isJson(timecard.overrides) ? JSON.parse(timecard.overrides) : this.overrides);
                        this.checkAllowanceMessage();
                        if (timecard.accrual_object && typeof(timecard.accrual_object) === 'object') this.accruals = timecard.accrual_object;
                        if (timecard.assignment_object.additional_allowances && typeof timecard.assignment_object.additional_allowances === 'object') this.assignment.additional_allowances = timecard.assignment_object.additional_allowances;
                        this.employee_comments = timecard.employee_comments;
                        this.employer_comments = timecard.employer_comments;
                        this.payroll_comments = this.previousPrComment = timecard.payroll_comments;
                        this.timezone_entered = parseInt(timecard.timezone_entered);
                        this.perLocked = true;
                        this.empLocked = true;

                        if (parseInt(timecard.payroll_status) > 0 || parseInt(timecard.status) >= 2 || parseInt(timecard.status) === 0) {
                            this.cardLocked = true;
                        } else if (this.type === 'employee' && (parseInt(timecard.employee_status) > 0 || parseInt(timecard.employer_status) > 0)) {
                            this.cardLocked = true;
                        } else {
                            this.cardLocked = false;
                        }

                        this.hash = hash;
                        this.time_added = timecard.time_added;
                        this.time_updated = timecard.time_updated;
                        this.user_can_approve = timecard.user_can_approve;
                        this.user_is_next_approver = timecard.user_is_next_approver;
                        this.user_is_final_approver = timecard.user_is_final_approver;
                        this.user_can_unlock = timecard.user_can_unlock;
                        this.batch_id = timecard.batch_id || '';
                        this.batch = timecard.batch || '';
                        this.employee_status = timecard.employee_status;
                        this.employer_status = timecard.employer_status;
                        this.status = timecard.status;
                        this.statusFull = timecard.status_full;
                        this.getAssets( { type: 'timecard', timecardId: timecard.id, assignmentId: timecard.assignment_object.id, employeeId: timecard.assignment_object.employee_id });
                        this.updateDays(this.weekEnding);
                        if (checkMinWage) {
                            this.checkMinWage();
                        }
                        if (checkStartStatus) {
                            this.checkStartStatus();
                        }
                        // console.log ("Timecard ID: " + timecard.id);
                    } else if (response.status == 400 || response.status == 403) {
                        if (Array.isArray(response.data)) {
                            let message = '';
                            for (let i = 0; i < response.data.length; i++) {
                                let error = JSON.parse(response.data[i]);
                                $("input[name='" + error.field + "']").addClass('form-error2');
                                message += error.message + "\n";
                            }
                            this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else if (response.data.message) {
                            this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                        } else {
                            this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                        }
                    } else {
                        this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK"  });
                    }
                })
                .catch(error => { console.log(error); })
                .finally(() => {
                    this.getReviews();
                    this.getHistory();
                    this.getPreviousApprovals();
                }
            );
        },

        // Kick back to an earlier approver.
        async kickbackApproval(approvalId=null, status=false) {
            if (!this.endpoints.tcApproval || !this.hash || !approvalId) return;
            // The true at the end allows for one patch to send it back multiple tiers
            const endpoint = `${this.endpoints.tcApproval}${this.hash}/${approvalId}/true`;
            const data = { status: status ? 1 : 0 };
            this.kickbackApproverModal = false;

            try {
                const response = await this.oasisV3Api.patch(endpoint, data);
                if (response.status == 200 && response.data && response.data.results) {
                    // normal case
                    const results = response.data.results;
                    this.createDialog({ "title": "Success", "body": "Timecard successfullly kicked back.", "buttonNo": true, "buttonNoLabel": "Stay Here", "buttonYesAction": function() { app.gotoNextTc(); }, "buttonYesLabel": "Go Next" });
                    this.statusFull = 'Returned for Approval';
                } else if (response.status === 400 || response.status === 422) {
                    if (Array.isArray(response.data)) {
                        let message = '';
                        for (let i = 0; i < response.data.length; i++) {
                            let error = JSON.parse(response.data[i]);
                            $("input[name='" + error.field + "']").addClass('form-error2');
                            message += error.message + "\n";
                        }
                        this.createDialog({ "title": "Error", "body": message, "buttonNo": false, "buttonYesLabel": "OK" });
                    } else if (response.data.message) {
                        this.createDialog({ "title": "Error", "body": response.data.message, "buttonNo": false, "buttonYesLabel": "OK" });
                    } else {
                        this.createDialog({ "title": "Error", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                    }
                } else {
                    this.createDialog({ "title": "Alert", "body": response.data, "buttonNo": false, "buttonYesLabel": "OK" });
                }
            } catch (error) {
                // this.$emit('message', error);
                console.log(error);
            } finally {
                this.kickbackApprovalId = null;
            }
        },
    },

    watch: {
    },

    beforeCreate() {
        this.oasisApi = new Axios('/restv2');

        let promises = [
            this.oasisApi.get('/projectlocations')
                .then(response => {
                    this.projectLocations = response.data;
                    return true;
                })
                .catch(error => {
                    console.log(error);
                    return false;
                }),

            this.oasisApi.get('/daytypes')
                .then(response => {
                    this.dayTypes = response.data;
                    return true;
                })
                .catch(error => {
                    console.log(error);
                    return false;
                }),

            this.oasisApi.get('/jobTitles')
                .then(response => {
                    this.jobTitles = response.data;
                    return true;
                })
                .catch(error => {
                    console.log(error);
                    return false;
                }),

            this.oasisApi.get('/projects')
                .then(response => {
                    this.allProjects = response.data;
                    return true;
                })
                .catch(error => {
                    console.log(error);
                    return false;
                }),
        ];

        this.waiting = true;
        Promise.all(promises)
            .then(results => {
                this.waiting = false;
            })
            .catch(error => {
                console.log(error);
                this.waiting = false;
            })
    },

     async created() {
        this.format = this.getDateFormat();
        if (typeof timecardType !== 'undefined') this.timecardType = timecardType;
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('new') !== 'true' && nextWeekEnding) {
            this.nextWeekEnding = nextWeekEnding;
            this.updateDays(nextWeekEnding);
        } else if (nextWeekEnding) {
            // Needed for bi-weekly validation
            this.nextWeekEnding = nextWeekEnding;
        }
        window.addEventListener("beforeunload", this.leavePage, false);

        // check chart of accounts
        if (type === 'employer') {
            let now = new Date();
            let currentTime = now.getTime();
            let COAObj = JSON.parse(window.localStorage.getItem(entityId + '#'));
            // If COA data is not loaded for unexpected reason in dashboard, will get COA data just in case here.
            if (!COAObj || (COAObj && COAObj.isLoaded == false)) {
                await this.getProbooksResources(currentTime);
                COAObj = JSON.parse(window.localStorage.getItem(entityId + '#'));
            }
            this.probooksAccounts =  COAObj.accounts || [];
            this.probooksFreeFields = COAObj.freeFields || [];
            this.probooksSeries = COAObj.series || [];
            this.probooksLocations = COAObj.locations || [];
            this.probooksSets = COAObj.sets || [];
            this.probooksProjects = COAObj.projects || [];

            if (!this.probooksAccounts || !this.probooksFreeFields || !this.probooksSeries || !this.probooksLocations || !this.probooksSets) {
                // data is not loaded in dashboard. do nothing.
                // ex) data is loaded, It will be return [](empty) - true. but data is not loaded, It will be return null
            } else if (this.probooksAccounts.length > 0 || this.probooksFreeFields.length > 0 || this.probooksSeries.length > 0 || this.probooksLocations.length > 0 || this.probooksSets.length > 0) {
                this.enableProBooks = true;
            }

            // load COA rules
            const responseCoaRules = await this.oasisV3Api.get(`/employer/coaRules?entity_id=${entityId}`)
            this.coaRules = responseCoaRules.data.results;
        }

        this.oasisApi.get('/departments')
            .then(response => {
                this.departments = response.data.results;
                return true;
            })
            .catch(error => {
                console.log(error);
                return false;
            }
        );

        this.oasisV3Api.get('/optionValues?option_type_id=24&status=1')
            .then(response => {
                this.allowanceRateUnits = response.data.results;
                return true;
            })
            .catch(error => {
                console.log(error);
                return false;
            }
        );

        this.oasisV3Api.get('/optionValues?option_type_id=23&status=1')
            .then(response => {
                this.unionLocations = response.data.results;
                return true;
            })
            .catch(error => {
                console.log(error);
                return false;
            }
        );
    },

    async mounted() {
        let response = await this.oasisApi.get('/entities');
        if ( (response.status == 200 || response.status == 201) && typeof response.data === 'object') {
            this.entity = response.data;

            if (response.data.hasOwnProperty('other_properties') && response.data.other_properties) {
                const data = this.isJson(response.data.other_properties) ? JSON.parse(response.data.other_properties) : response.data.other_properties;
                this.showProjects = data.showProjects || false; 
                this.showAssignedProjects = data.showAssignedProjects || false; 
                this.showAccountString = data.showAccounts || false; 
                this.showOverrideMPs = data.overrideMPs || false; 
                this.showBatches = data.showBatches || false;
                this.accountString = data.accountString || {};
                this.allowanceLocked = data.employeeAllowancesLocked || false;
                this.enableWorkDay = data.enableWorkDay || false;
                this.enableApproveButton = data.enableApproveButton || false;
                this.excludeVacPay = data.excludeVacPay || false;
                this.defaultLaborSubtotal = data.defaultLaborSubtotal || false;
                this.additionalBreakouts = data.additionalBreakouts || false;
                this.useSignatories = data.useSignatories || false;

                if (this.useSignatories) {
                    let url = '/employer/signatories/';
                    try {
                        const response = await this.oasisV3Api.get(url);
                        this.signatories = response.data.results;
                    } catch (error) {
                        this.$emit('message', error);
                        console.log(error);
                    }
                }
            }
        }

        // Load data provided by server, if any
        // load either the correct employee or list of employees (assignments, really)
        this.endpoints.otherPayTypes = '/otherPayTypes';
        if (type === 'employer') {
            this.type = 'employer';
            this.endpoints.timecard = '/timecard/';
            this.endpoints.timecardLoadByHash = '/timecard/card/';
            this.endpoints.timecardEmployee = '/timecard/employee/';
            this.endpoints.timecardEmployeeApprove = 'approve/timecardEmployee/';
            this.endpoints.timecardPrevious = '/timecard/previous/';
            this.endpoints.timecardRelated = '/relatedTimecards/';
            this.endpoints.history = '/timecard/history/';
            this.endpoints.reviews = '/review/timecard/';
            this.endpoints.employee = '/employees/';
            this.endpoints.dashboard = '/oasis/welcome/dashboard';
            this.endpoints.accrual = '/employee/accrual/';
            this.endpoints.assignment = '/assignments/';
            this.endpoints.assignmentTotals = '/employer/timecardTotals/';
            this.endpoints.tcApproval = '/employer/timecardApprovals/';

            if (typeof (availableAssignments) !== 'undefined') { this.employees = availableAssignments; }
        } else if (type === 'employee') {
            this.type = 'employee';
            this.endpoints.timecard = '/employee/timecard/calc/';
            this.endpoints.timecardLoadByHash = '/employee/timecard/card/';
            this.endpoints.timecardEmployee = '/employee/timecard/lookup/';
            this.endpoints.timecardEmployeeApprove = '/employee/timecard/approve/';
            this.endpoints.timecardPrevious = '/employee/timecard/previous/';
            this.endpoints.history = '';
            this.endpoints.reviews = null;
            this.endpoints.employee = '/employee/lookup/';
            this.endpoints.dashboard = '/oasis/employee/dashboard/prompt';
            this.endpoints.accrual = '/employee/accrual/';
            this.endpoints.assignment = null;
            this.endpoints.assignmentTotals = '/employee/timecardTotals/';
            this.endpoints.tcApproval = '';
        } else {
            return undefined;
        }

        // If going to a specific timecard
        if (hash) {
            this.isNew = false;
            // Load list of timecards
            if (type === 'employer') this.loadTCList();

            this.loadByHash(hash);

        // Creating a new timecard with a pre-defined assignment
        } else if (assignmentHash) {
            let employee = this.employees.find(({ hash }) => hash == assignmentHash) || null;
            if (employee) {
                this.updateAssignment(employee);
                this.defaultLocation = { "name": employee.location, "id": employee.location_id };
                this.lookupTimecard(employee);
            }
        } else {
            // employee is passed from server as a JS variable
            if (type === 'employee') {
                let employee = undefined;
                if (assignmentId && employees) {
                    employee = employees.find(({ id }) => id == assignmentId);
                } else {
                    console.log ('error');
                }
                if (employee) {
                    this.updateAssignment(employee);
                    this.defaultLocation = { "name": employee.location, "id": employee.location_id };
                    if (this.weekEnding) {
                        this.lookupTimecard(this.assignment);
                    }
                }
            }
        }

        this.oasisApi.get(this.endpoints.otherPayTypes)
            .then(response => {
                if (response.status === 200) {
                    this.otherPayTypes = response.data.results
                } else {
                    console.log('Failed to get other pay types')
                }
            })
            .catch(error => {
                console.log(error);
            })

        // Disable Timecards
        if (disableTimecards) {
            this.readOnly = true;
            this.empLocked = true;
            this.perLocked = true;
            this.cardLocked = true;
        }
        $("input[name='employee']").focus();

        // Prevent back button from failing.
        history.pushState(null, document.referrer, location.href);
        window.onpopstate = function () {
            window.location.href = document.referrer;
        };

        this.adminAccess = typeof adminAccess !== 'undefined' ? (adminAccess ? true : false) : false;
    },

    beforeUnmount () {
        window.removeEventListener("beforeunload", this.leavePage);
    }
}).mount("#timecard-app");
